/* tslint:disable */
/* eslint-disable */
/**
 * Regalmonitor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 *
 * @export
 * @interface AddressIO
 */
export interface AddressIO {
  /**
   *
   * @type {number}
   * @memberof AddressIO
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AddressIO
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof AddressIO
   */
  houseNumber?: string;
  /**
   *
   * @type {number}
   * @memberof AddressIO
   */
  zip?: number;
  /**
   *
   * @type {string}
   * @memberof AddressIO
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof AddressIO
   */
  district?: string | null;
}
/**
 *
 * @export
 * @interface AddressIOJsonld
 */
export interface AddressIOJsonld {
  /**
   *
   * @type {number}
   * @memberof AddressIOJsonld
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AddressIOJsonld
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof AddressIOJsonld
   */
  houseNumber?: string;
  /**
   *
   * @type {number}
   * @memberof AddressIOJsonld
   */
  zip?: number;
  /**
   *
   * @type {string}
   * @memberof AddressIOJsonld
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof AddressIOJsonld
   */
  district?: string | null;
}
/**
 *
 * @export
 * @interface AddressIOMultipart
 */
export interface AddressIOMultipart {
  /**
   *
   * @type {number}
   * @memberof AddressIOMultipart
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AddressIOMultipart
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof AddressIOMultipart
   */
  houseNumber?: string;
  /**
   *
   * @type {number}
   * @memberof AddressIOMultipart
   */
  zip?: number;
  /**
   *
   * @type {string}
   * @memberof AddressIOMultipart
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof AddressIOMultipart
   */
  district?: string | null;
}
/**
 * Market.Component.Article.Type.MarketComponentArticleTypeOutput.jsonld collection.
 * @export
 * @interface ApiMarketComponentArticleTypesGetCollection200Response
 */
export interface ApiMarketComponentArticleTypesGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiMarketComponentArticleTypesGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiMarketComponentArticleTypesGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {Array<MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld>}
   * @memberof ApiMarketComponentArticleTypesGetCollection200Response
   */
  member: Array<MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld>;
}
/**
 * Market.Component.History.MarketComponentHistoryOutput.jsonld collection.
 * @export
 * @interface ApiMarketComponentHistoriemarketMarketIdGetCollection200Response
 */
export interface ApiMarketComponentHistoriemarketMarketIdGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiMarketComponentHistoriemarketMarketIdGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiMarketComponentHistoriemarketMarketIdGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {HydraCollectionBaseSchemaAllOfView}
   * @memberof ApiMarketComponentHistoriemarketMarketIdGetCollection200Response
   */
  view?: HydraCollectionBaseSchemaAllOfView;
  /**
   *
   * @type {Array<MarketComponentHistoryMarketComponentHistoryOutputJsonld>}
   * @memberof ApiMarketComponentHistoriemarketMarketIdGetCollection200Response
   */
  member: Array<MarketComponentHistoryMarketComponentHistoryOutputJsonld>;
}
/**
 * Market.Component.Type.MarketComponentTypeOutput.jsonld collection.
 * @export
 * @interface ApiMarketComponentTypesGetCollection200Response
 */
export interface ApiMarketComponentTypesGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiMarketComponentTypesGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiMarketComponentTypesGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {Array<MarketComponentTypeMarketComponentTypeOutputJsonld>}
   * @memberof ApiMarketComponentTypesGetCollection200Response
   */
  member: Array<MarketComponentTypeMarketComponentTypeOutputJsonld>;
}
/**
 * Market.Component.MarketComponentIO.jsonld collection.
 * @export
 * @interface ApiMarketComponentsMarketIdGetCollection200Response
 */
export interface ApiMarketComponentsMarketIdGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiMarketComponentsMarketIdGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiMarketComponentsMarketIdGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {Array<MarketComponentMarketComponentIOJsonld>}
   * @memberof ApiMarketComponentsMarketIdGetCollection200Response
   */
  member: Array<MarketComponentMarketComponentIOJsonld>;
}
/**
 * Market.MarketIO.jsonld collection.
 * @export
 * @interface ApiMarketsGetCollection200Response
 */
export interface ApiMarketsGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiMarketsGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiMarketsGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {Array<MarketMarketIOJsonld>}
   * @memberof ApiMarketsGetCollection200Response
   */
  member: Array<MarketMarketIOJsonld>;
}
/**
 * Reporting.MarketComponentHistoryOutput.jsonld collection.
 * @export
 * @interface ApiReportingmarketComponentHistoryGetCollection200Response
 */
export interface ApiReportingmarketComponentHistoryGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiReportingmarketComponentHistoryGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiReportingmarketComponentHistoryGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {HydraCollectionBaseSchemaAllOfView}
   * @memberof ApiReportingmarketComponentHistoryGetCollection200Response
   */
  view?: HydraCollectionBaseSchemaAllOfView;
  /**
   *
   * @type {Array<ReportingMarketComponentHistoryOutputJsonld>}
   * @memberof ApiReportingmarketComponentHistoryGetCollection200Response
   */
  member: Array<ReportingMarketComponentHistoryOutputJsonld>;
}
/**
 * Reporting.MarketComponentOutput.jsonld collection.
 * @export
 * @interface ApiReportingmarketComponentReportGetCollection200Response
 */
export interface ApiReportingmarketComponentReportGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiReportingmarketComponentReportGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiReportingmarketComponentReportGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {HydraCollectionBaseSchemaAllOfView}
   * @memberof ApiReportingmarketComponentReportGetCollection200Response
   */
  view?: HydraCollectionBaseSchemaAllOfView;
  /**
   *
   * @type {Array<ReportingMarketComponentOutputJsonld>}
   * @memberof ApiReportingmarketComponentReportGetCollection200Response
   */
  member: Array<ReportingMarketComponentOutputJsonld>;
}
/**
 * Reporting.UserOutput.jsonld collection.
 * @export
 * @interface ApiReportinguserGetCollection200Response
 */
export interface ApiReportinguserGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiReportinguserGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiReportinguserGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {HydraCollectionBaseSchemaAllOfView}
   * @memberof ApiReportinguserGetCollection200Response
   */
  view?: HydraCollectionBaseSchemaAllOfView;
  /**
   *
   * @type {Array<ReportingUserOutputJsonld>}
   * @memberof ApiReportinguserGetCollection200Response
   */
  member: Array<ReportingUserOutputJsonld>;
}
/**
 * User.UserIO.jsonld collection.
 * @export
 * @interface ApiUsersGetCollection200Response
 */
export interface ApiUsersGetCollection200Response {
  /**
   *
   * @type {number}
   * @memberof ApiUsersGetCollection200Response
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof ApiUsersGetCollection200Response
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {Array<UserUserIOJsonld>}
   * @memberof ApiUsersGetCollection200Response
   */
  member: Array<UserUserIOJsonld>;
}
/**
 *
 * @export
 * @interface AreaIO
 */
export interface AreaIO {
  /**
   *
   * @type {number}
   * @memberof AreaIO
   */
  height?: number;
  /**
   *
   * @type {number}
   * @memberof AreaIO
   */
  width?: number;
}
/**
 *
 * @export
 * @interface AreaIOJsonld
 */
export interface AreaIOJsonld {
  /**
   *
   * @type {number}
   * @memberof AreaIOJsonld
   */
  height?: number;
  /**
   *
   * @type {number}
   * @memberof AreaIOJsonld
   */
  width?: number;
}
/**
 *
 * @export
 * @interface AreaIOMultipart
 */
export interface AreaIOMultipart {
  /**
   *
   * @type {number}
   * @memberof AreaIOMultipart
   */
  height?: number;
  /**
   *
   * @type {number}
   * @memberof AreaIOMultipart
   */
  width?: number;
}
/**
 * Unprocessable entity
 * @export
 * @interface ConstraintViolation
 */
export interface ConstraintViolation {
  /**
   *
   * @type {number}
   * @memberof ConstraintViolation
   */
  status?: number;
  /**
   *
   * @type {Array<ConstraintViolationViolationsInner>}
   * @memberof ConstraintViolation
   */
  violations?: Array<ConstraintViolationViolationsInner>;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolation
   */
  detail?: string;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolation
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolation
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolation
   */
  instance?: string | null;
}
/**
 * Unprocessable entity
 * @export
 * @interface ConstraintViolationJsonld
 */
export interface ConstraintViolationJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof ConstraintViolationJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  "@type": string;
  /**
   *
   * @type {number}
   * @memberof ConstraintViolationJsonld
   */
  status?: number;
  /**
   *
   * @type {Array<ConstraintViolationViolationsInner>}
   * @memberof ConstraintViolationJsonld
   */
  violations?: Array<ConstraintViolationViolationsInner>;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  detail?: string;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof ConstraintViolationJsonld
   */
  instance?: string | null;
}
/**
 *
 * @export
 * @interface ConstraintViolationViolationsInner
 */
export interface ConstraintViolationViolationsInner {
  /**
   * The property path of the violation
   * @type {string}
   * @memberof ConstraintViolationViolationsInner
   */
  propertyPath: string;
  /**
   * The message associated with the violation
   * @type {string}
   * @memberof ConstraintViolationViolationsInner
   */
  message: string;
  /**
   * The code of the violation
   * @type {string}
   * @memberof ConstraintViolationViolationsInner
   */
  code?: string;
  /**
   * An extra hint to understand the violation
   * @type {string}
   * @memberof ConstraintViolationViolationsInner
   */
  hint?: string;
  /**
   * The serialized payload of the violation
   * @type {{ [key: string]: any; }}
   * @memberof ConstraintViolationViolationsInner
   */
  payload?: { [key: string]: any };
}
/**
 * A representation of common errors.
 * @export
 * @interface ErrorJsonld
 */
export interface ErrorJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof ErrorJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof ErrorJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof ErrorJsonld
   */
  "@type": string;
  /**
   * A short, human-readable summary of the problem.
   * @type {string}
   * @memberof ErrorJsonld
   */
  title?: string | null;
  /**
   * A human-readable explanation specific to this occurrence of the problem.
   * @type {string}
   * @memberof ErrorJsonld
   */
  detail?: string | null;
  /**
   *
   * @type {number}
   * @memberof ErrorJsonld
   */
  status?: number | null;
  /**
   * A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.
   * @type {string}
   * @memberof ErrorJsonld
   */
  instance?: string | null;
  /**
   * A URI reference that identifies the problem type
   * @type {string}
   * @memberof ErrorJsonld
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ErrorJsonld
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface FileJsonld
 */
export interface FileJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof FileJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof FileJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof FileJsonld
   */
  "@type": string;
}
/**
 *
 * @export
 * @interface FileSuccessOutput
 */
export interface FileSuccessOutput {
  /**
   *
   * @type {string}
   * @memberof FileSuccessOutput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof FileSuccessOutput
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface FileSuccessOutputJsonld
 */
export interface FileSuccessOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof FileSuccessOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof FileSuccessOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof FileSuccessOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof FileSuccessOutputJsonld
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof FileSuccessOutputJsonld
   */
  details?: string | null;
}
/**
 * valid values for FileTargets
 * @export
 * @enum {string}
 */

export const FileTargets = {
  MarketDrawing: "market_drawing",
} as const;

export type FileTargets = (typeof FileTargets)[keyof typeof FileTargets];

/**
 *
 * @export
 * @interface HydraCollectionBaseSchema
 */
export interface HydraCollectionBaseSchema {
  /**
   *
   * @type {number}
   * @memberof HydraCollectionBaseSchema
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof HydraCollectionBaseSchema
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
  /**
   *
   * @type {HydraCollectionBaseSchemaAllOfView}
   * @memberof HydraCollectionBaseSchema
   */
  view?: HydraCollectionBaseSchemaAllOfView;
}
/**
 *
 * @export
 * @interface HydraCollectionBaseSchemaAllOfView
 */
export interface HydraCollectionBaseSchemaAllOfView {
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaAllOfView
   */
  "@id"?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaAllOfView
   */
  "@type"?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaAllOfView
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaAllOfView
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaAllOfView
   */
  previous?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaAllOfView
   */
  next?: string;
}
/**
 *
 * @export
 * @interface HydraCollectionBaseSchemaNoPagination
 */
export interface HydraCollectionBaseSchemaNoPagination {
  /**
   *
   * @type {number}
   * @memberof HydraCollectionBaseSchemaNoPagination
   */
  totalItems?: number;
  /**
   *
   * @type {HydraCollectionBaseSchemaNoPaginationSearch}
   * @memberof HydraCollectionBaseSchemaNoPagination
   */
  search?: HydraCollectionBaseSchemaNoPaginationSearch;
}
/**
 *
 * @export
 * @interface HydraCollectionBaseSchemaNoPaginationSearch
 */
export interface HydraCollectionBaseSchemaNoPaginationSearch {
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearch
   */
  "@type"?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearch
   */
  template?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearch
   */
  variableRepresentation?: string;
  /**
   *
   * @type {Array<HydraCollectionBaseSchemaNoPaginationSearchMappingInner>}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearch
   */
  mapping?: Array<HydraCollectionBaseSchemaNoPaginationSearchMappingInner>;
}
/**
 *
 * @export
 * @interface HydraCollectionBaseSchemaNoPaginationSearchMappingInner
 */
export interface HydraCollectionBaseSchemaNoPaginationSearchMappingInner {
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearchMappingInner
   */
  "@type"?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearchMappingInner
   */
  variable?: string;
  /**
   *
   * @type {string}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearchMappingInner
   */
  property?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof HydraCollectionBaseSchemaNoPaginationSearchMappingInner
   */
  required?: boolean;
}
/**
 *
 * @export
 * @interface HydraItemBaseSchema
 */
export interface HydraItemBaseSchema {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof HydraItemBaseSchema
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof HydraItemBaseSchema
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof HydraItemBaseSchema
   */
  "@type": string;
}
/**
 * @type HydraItemBaseSchemaContext
 * @export
 */
export type HydraItemBaseSchemaContext =
  HydraItemBaseSchemaContextOneOf | string;

/**
 *
 * @export
 * @interface HydraItemBaseSchemaContextOneOf
 */
export interface HydraItemBaseSchemaContextOneOf {
  [key: string]: any;

  /**
   *
   * @type {string}
   * @memberof HydraItemBaseSchemaContextOneOf
   */
  "@vocab": string;
  /**
   *
   * @type {string}
   * @memberof HydraItemBaseSchemaContextOneOf
   */
  hydra: HydraItemBaseSchemaContextOneOfHydraEnum;
}

export const HydraItemBaseSchemaContextOneOfHydraEnum = {
  HttpWwwW3OrgNsHydraCore: "http://www.w3.org/ns/hydra/core#",
} as const;

export type HydraItemBaseSchemaContextOneOfHydraEnum =
  (typeof HydraItemBaseSchemaContextOneOfHydraEnum)[keyof typeof HydraItemBaseSchemaContextOneOfHydraEnum];

/**
 * valid values for LanguageCode
 * @export
 * @enum {string}
 */

export const LanguageCode = {
  DeDe: "de-DE",
  EnGb: "en-GB",
  EnUs: "en-US",
} as const;

export type LanguageCode = (typeof LanguageCode)[keyof typeof LanguageCode];

/**
 *
 * @export
 * @interface LoggingLoggingInput
 */
export interface LoggingLoggingInput {
  /**
   *
   * @type {string}
   * @memberof LoggingLoggingInput
   */
  type?: string;
  /**
   *
   * @type {{ [key: string]: string | null; }}
   * @memberof LoggingLoggingInput
   */
  labels?: { [key: string]: string | null };
  /**
   *
   * @type {string}
   * @memberof LoggingLoggingInput
   */
  content?: string;
}
/**
 *
 * @export
 * @interface LoggingSuccessOutput
 */
export interface LoggingSuccessOutput {
  /**
   *
   * @type {string}
   * @memberof LoggingSuccessOutput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof LoggingSuccessOutput
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface LoggingSuccessOutputJsonld
 */
export interface LoggingSuccessOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof LoggingSuccessOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof LoggingSuccessOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof LoggingSuccessOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof LoggingSuccessOutputJsonld
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof LoggingSuccessOutputJsonld
   */
  details?: string | null;
}
/**
 * valid values for LoggingType
 * @export
 * @enum {string}
 */

export const LoggingType = {
  Info: "INFO",
  Error: "ERROR",
  Trace: "TRACE",
} as const;

export type LoggingType = (typeof LoggingType)[keyof typeof LoggingType];

/**
 *
 * @export
 * @interface LoginCheckPost200Response
 */
export interface LoginCheckPost200Response {
  /**
   *
   * @type {string}
   * @memberof LoginCheckPost200Response
   */
  token: string;
}
/**
 *
 * @export
 * @interface LoginCheckPostRequest
 */
export interface LoginCheckPostRequest {
  /**
   *
   * @type {string}
   * @memberof LoginCheckPostRequest
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof LoginCheckPostRequest
   */
  password: string;
}
/**
 *
 * @export
 * @interface LogoutSuccessOutput
 */
export interface LogoutSuccessOutput {
  /**
   *
   * @type {string}
   * @memberof LogoutSuccessOutput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof LogoutSuccessOutput
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface LogoutSuccessOutputJsonld
 */
export interface LogoutSuccessOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof LogoutSuccessOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof LogoutSuccessOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof LogoutSuccessOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof LogoutSuccessOutputJsonld
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof LogoutSuccessOutputJsonld
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface MarketComponentArticleTypeMarketComponentArticleTypeOutput
 */
export interface MarketComponentArticleTypeMarketComponentArticleTypeOutput {
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutput
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutput
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutput
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutput
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutput
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutput
   */
  daysBeforeSwitchToRed?: number;
}
/**
 *
 * @export
 * @interface MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
 */
export interface MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentArticleTypeMarketComponentArticleTypeOutputJsonld
   */
  daysBeforeSwitchToRed?: number;
}
/**
 *
 * @export
 * @interface MarketComponentHistoryMarketComponentHistoryOutput
 */
export interface MarketComponentHistoryMarketComponentHistoryOutput {
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutput
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutput
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutput
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutput
   */
  marketComponentName?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutput
   */
  criticalDate?: string | null;
  /**
   *
   * @type {MetaOutput}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutput
   */
  metaOutput?: MetaOutput | null;
}
/**
 *
 * @export
 * @interface MarketComponentHistoryMarketComponentHistoryOutputJsonld
 */
export interface MarketComponentHistoryMarketComponentHistoryOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  marketComponentName?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  criticalDate?: string | null;
  /**
   *
   * @type {MetaOutputJsonld}
   * @memberof MarketComponentHistoryMarketComponentHistoryOutputJsonld
   */
  metaOutput?: MetaOutputJsonld | null;
}
/**
 *
 * @export
 * @interface MarketComponentIO
 */
export interface MarketComponentIO {
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  id?: number | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  svgTemplate?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  articleTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  articleType?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  typeId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  marketId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  orientation?: number;
  /**
   *
   * @type {PositionOutput}
   * @memberof MarketComponentIO
   */
  position?: PositionOutput;
  /**
   *
   * @type {SizeOutput}
   * @memberof MarketComponentIO
   */
  size?: SizeOutput;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  switchToRedAfterDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  daysBeforeSwitchToRed?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIO
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIO
   */
  marketComponentStatus?: MarketComponentIOMarketComponentStatusEnum;
}

export const MarketComponentIOMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type MarketComponentIOMarketComponentStatusEnum =
  (typeof MarketComponentIOMarketComponentStatusEnum)[keyof typeof MarketComponentIOMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface MarketComponentIOJsonld
 */
export interface MarketComponentIOJsonld {
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  id?: number | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  svgTemplate?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  articleTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  articleType?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  typeId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  marketId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  orientation?: number;
  /**
   *
   * @type {PositionOutputJsonld}
   * @memberof MarketComponentIOJsonld
   */
  position?: PositionOutputJsonld;
  /**
   *
   * @type {SizeOutputJsonld}
   * @memberof MarketComponentIOJsonld
   */
  size?: SizeOutputJsonld;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  switchToRedAfterDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  daysBeforeSwitchToRed?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOJsonld
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOJsonld
   */
  marketComponentStatus?: MarketComponentIOJsonldMarketComponentStatusEnum;
}

export const MarketComponentIOJsonldMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type MarketComponentIOJsonldMarketComponentStatusEnum =
  (typeof MarketComponentIOJsonldMarketComponentStatusEnum)[keyof typeof MarketComponentIOJsonldMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface MarketComponentIOMultipart
 */
export interface MarketComponentIOMultipart {
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  id?: number | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  svgTemplate?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  articleTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  articleType?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  typeId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  marketId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  orientation?: number;
  /**
   *
   * @type {PositionOutputMultipart}
   * @memberof MarketComponentIOMultipart
   */
  position?: PositionOutputMultipart;
  /**
   *
   * @type {SizeOutputMultipart}
   * @memberof MarketComponentIOMultipart
   */
  size?: SizeOutputMultipart;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  switchToRedAfterDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  daysBeforeSwitchToRed?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentIOMultipart
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentIOMultipart
   */
  marketComponentStatus?: MarketComponentIOMultipartMarketComponentStatusEnum;
}

export const MarketComponentIOMultipartMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type MarketComponentIOMultipartMarketComponentStatusEnum =
  (typeof MarketComponentIOMultipartMarketComponentStatusEnum)[keyof typeof MarketComponentIOMultipartMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface MarketComponentMarketComponentCollectionIO
 */
export interface MarketComponentMarketComponentCollectionIO {
  /**
   *
   * @type {Array<MarketComponentIO>}
   * @memberof MarketComponentMarketComponentCollectionIO
   */
  marketComponentIOs?: Array<MarketComponentIO>;
}
/**
 *
 * @export
 * @interface MarketComponentMarketComponentCollectionIOJsonld
 */
export interface MarketComponentMarketComponentCollectionIOJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketComponentMarketComponentCollectionIOJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentCollectionIOJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentCollectionIOJsonld
   */
  "@type": string;
  /**
   *
   * @type {Array<MarketComponentIOJsonld>}
   * @memberof MarketComponentMarketComponentCollectionIOJsonld
   */
  marketComponentIOs?: Array<MarketComponentIOJsonld>;
}
/**
 *
 * @export
 * @interface MarketComponentMarketComponentIO
 */
export interface MarketComponentMarketComponentIO {
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  id?: number | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  svgTemplate?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  articleTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  articleType?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  typeId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  marketId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  orientation?: number;
  /**
   *
   * @type {PositionOutput}
   * @memberof MarketComponentMarketComponentIO
   */
  position?: PositionOutput;
  /**
   *
   * @type {SizeOutput}
   * @memberof MarketComponentMarketComponentIO
   */
  size?: SizeOutput;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  switchToRedAfterDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  daysBeforeSwitchToRed?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIO
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIO
   */
  marketComponentStatus?: MarketComponentMarketComponentIOMarketComponentStatusEnum;
}

export const MarketComponentMarketComponentIOMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type MarketComponentMarketComponentIOMarketComponentStatusEnum =
  (typeof MarketComponentMarketComponentIOMarketComponentStatusEnum)[keyof typeof MarketComponentMarketComponentIOMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface MarketComponentMarketComponentIOJsonld
 */
export interface MarketComponentMarketComponentIOJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  "@type": string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  id?: number | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  svgTemplate?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  articleTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  articleType?: string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  typeId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  marketId?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  number?: number | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  orientation?: number;
  /**
   *
   * @type {PositionOutputJsonld}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  position?: PositionOutputJsonld;
  /**
   *
   * @type {SizeOutputJsonld}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  size?: SizeOutputJsonld;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  switchToYellowAfterXDays?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  switchToRedAfterXDays?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  switchToRedAfterDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  daysBeforeSwitchToRed?: number;
  /**
   *
   * @type {number}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentIOJsonld
   */
  marketComponentStatus?: MarketComponentMarketComponentIOJsonldMarketComponentStatusEnum;
}

export const MarketComponentMarketComponentIOJsonldMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type MarketComponentMarketComponentIOJsonldMarketComponentStatusEnum =
  (typeof MarketComponentMarketComponentIOJsonldMarketComponentStatusEnum)[keyof typeof MarketComponentMarketComponentIOJsonldMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface MarketComponentMarketComponentStatusDateInput
 */
export interface MarketComponentMarketComponentStatusDateInput {
  /**
   *
   * @type {string}
   * @memberof MarketComponentMarketComponentStatusDateInput
   */
  date?: string | null;
}
/**
 * valid values for MarketComponentStatus
 * @export
 * @enum {string}
 */

export const MarketComponentStatus = {
  Green45b33f: "GREEN|#45b33f",
  GreenCyan00B28B: "GREEN_CYAN|#00B28B",
  YellowEaed00: "YELLOW|#eaed00",
  RedCd0404: "RED|#cd0404",
  WhiteFfffff: "WHITE|#FFFFFF",
  Unknown252525: "UNKNOWN|#252525",
} as const;

export type MarketComponentStatus =
  (typeof MarketComponentStatus)[keyof typeof MarketComponentStatus];

/**
 *
 * @export
 * @interface MarketComponentSuccessOutput
 */
export interface MarketComponentSuccessOutput {
  /**
   *
   * @type {string}
   * @memberof MarketComponentSuccessOutput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentSuccessOutput
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface MarketComponentSuccessOutputJsonld
 */
export interface MarketComponentSuccessOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketComponentSuccessOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketComponentSuccessOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentSuccessOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentSuccessOutputJsonld
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentSuccessOutputJsonld
   */
  details?: string | null;
}
/**
 * valid values for MarketComponentTypeCategory
 * @export
 * @enum {string}
 */

export const MarketComponentTypeCategory = {
  Checkout: "checkout",
  Cooling: "cooling",
  Drinks: "drinks",
  DryGoodsAssortment: "dry_goods_assortment",
  FruitVegetable: "fruit_vegetable",
  HighRack: "high_rack",
  Others: "others",
  Standee: "standee",
  Warehouse: "warehouse",
} as const;

export type MarketComponentTypeCategory =
  (typeof MarketComponentTypeCategory)[keyof typeof MarketComponentTypeCategory];

/**
 *
 * @export
 * @interface MarketComponentTypeMarketComponentTypeOutput
 */
export interface MarketComponentTypeMarketComponentTypeOutput {
  /**
   *
   * @type {number}
   * @memberof MarketComponentTypeMarketComponentTypeOutput
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutput
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutput
   */
  svgTemplate?: string;
  /**
   *
   * @type {SizeOutput}
   * @memberof MarketComponentTypeMarketComponentTypeOutput
   */
  size?: SizeOutput;
  /**
   *
   * @type {number}
   * @memberof MarketComponentTypeMarketComponentTypeOutput
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutput
   */
  category?: MarketComponentTypeMarketComponentTypeOutputCategoryEnum;
}

export const MarketComponentTypeMarketComponentTypeOutputCategoryEnum = {
  Checkout: "checkout",
  Cooling: "cooling",
  Drinks: "drinks",
  DryGoodsAssortment: "dry_goods_assortment",
  FruitVegetable: "fruit_vegetable",
  HighRack: "high_rack",
  Others: "others",
  Standee: "standee",
  Warehouse: "warehouse",
} as const;

export type MarketComponentTypeMarketComponentTypeOutputCategoryEnum =
  (typeof MarketComponentTypeMarketComponentTypeOutputCategoryEnum)[keyof typeof MarketComponentTypeMarketComponentTypeOutputCategoryEnum];

/**
 *
 * @export
 * @interface MarketComponentTypeMarketComponentTypeOutputJsonld
 */
export interface MarketComponentTypeMarketComponentTypeOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {number}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  svgTemplate?: string;
  /**
   *
   * @type {SizeOutputJsonld}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  size?: SizeOutputJsonld;
  /**
   *
   * @type {number}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  textLength?: number;
  /**
   *
   * @type {string}
   * @memberof MarketComponentTypeMarketComponentTypeOutputJsonld
   */
  category?: MarketComponentTypeMarketComponentTypeOutputJsonldCategoryEnum;
}

export const MarketComponentTypeMarketComponentTypeOutputJsonldCategoryEnum = {
  Checkout: "checkout",
  Cooling: "cooling",
  Drinks: "drinks",
  DryGoodsAssortment: "dry_goods_assortment",
  FruitVegetable: "fruit_vegetable",
  HighRack: "high_rack",
  Others: "others",
  Standee: "standee",
  Warehouse: "warehouse",
} as const;

export type MarketComponentTypeMarketComponentTypeOutputJsonldCategoryEnum =
  (typeof MarketComponentTypeMarketComponentTypeOutputJsonldCategoryEnum)[keyof typeof MarketComponentTypeMarketComponentTypeOutputJsonldCategoryEnum];

/**
 * valid values for MarketComponentTypePlaceholder
 * @export
 * @enum {string}
 */

export const MarketComponentTypePlaceholder = {
  Color: "COLOR",
  Text: "TEXT",
} as const;

export type MarketComponentTypePlaceholder =
  (typeof MarketComponentTypePlaceholder)[keyof typeof MarketComponentTypePlaceholder];

/**
 *
 * @export
 * @interface MarketConfigurationIO
 */
export interface MarketConfigurationIO {
  /**
   *
   * @type {AreaIO}
   * @memberof MarketConfigurationIO
   */
  area?: AreaIO;
  /**
   *
   * @type {string}
   * @memberof MarketConfigurationIO
   */
  filenameMarketDrawing?: string;
  /**
   *
   * @type {string}
   * @memberof MarketConfigurationIO
   */
  originalFilenameMarketDrawing?: string;
  /**
   *
   * @type {boolean}
   * @memberof MarketConfigurationIO
   */
  enableMarketDrawing?: boolean;
}
/**
 *
 * @export
 * @interface MarketConfigurationIOJsonld
 */
export interface MarketConfigurationIOJsonld {
  /**
   *
   * @type {AreaIOJsonld}
   * @memberof MarketConfigurationIOJsonld
   */
  area?: AreaIOJsonld;
  /**
   *
   * @type {string}
   * @memberof MarketConfigurationIOJsonld
   */
  filenameMarketDrawing?: string;
  /**
   *
   * @type {string}
   * @memberof MarketConfigurationIOJsonld
   */
  originalFilenameMarketDrawing?: string;
  /**
   *
   * @type {boolean}
   * @memberof MarketConfigurationIOJsonld
   */
  enableMarketDrawing?: boolean;
}
/**
 *
 * @export
 * @interface MarketConfigurationIOMultipart
 */
export interface MarketConfigurationIOMultipart {
  /**
   *
   * @type {AreaIOMultipart}
   * @memberof MarketConfigurationIOMultipart
   */
  area?: AreaIOMultipart;
  /**
   *
   * @type {string}
   * @memberof MarketConfigurationIOMultipart
   */
  filenameMarketDrawing?: string;
  /**
   *
   * @type {string}
   * @memberof MarketConfigurationIOMultipart
   */
  originalFilenameMarketDrawing?: string;
  /**
   *
   * @type {boolean}
   * @memberof MarketConfigurationIOMultipart
   */
  enableMarketDrawing?: boolean;
}
/**
 *
 * @export
 * @interface MarketIOLight
 */
export interface MarketIOLight {
  /**
   *
   * @type {number}
   * @memberof MarketIOLight
   */
  id?: number;
}
/**
 *
 * @export
 * @interface MarketIOLightJsonld
 */
export interface MarketIOLightJsonld {
  /**
   *
   * @type {number}
   * @memberof MarketIOLightJsonld
   */
  id?: number;
}
/**
 *
 * @export
 * @interface MarketIOLightMultipart
 */
export interface MarketIOLightMultipart {
  /**
   *
   * @type {number}
   * @memberof MarketIOLightMultipart
   */
  id?: number;
}
/**
 *
 * @export
 * @interface MarketMarketIO
 */
export interface MarketMarketIO {
  /**
   *
   * @type {number}
   * @memberof MarketMarketIO
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MarketMarketIO
   */
  name?: string;
  /**
   *
   * @type {MarketConfigurationIO}
   * @memberof MarketMarketIO
   */
  configuration?: MarketConfigurationIO;
  /**
   *
   * @type {AddressIO}
   * @memberof MarketMarketIO
   */
  address?: AddressIO;
}
/**
 *
 * @export
 * @interface MarketMarketIOJsonld
 */
export interface MarketMarketIOJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof MarketMarketIOJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof MarketMarketIOJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof MarketMarketIOJsonld
   */
  "@type": string;
  /**
   *
   * @type {number}
   * @memberof MarketMarketIOJsonld
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof MarketMarketIOJsonld
   */
  name?: string;
  /**
   *
   * @type {MarketConfigurationIOJsonld}
   * @memberof MarketMarketIOJsonld
   */
  configuration?: MarketConfigurationIOJsonld;
  /**
   *
   * @type {AddressIOJsonld}
   * @memberof MarketMarketIOJsonld
   */
  address?: AddressIOJsonld;
}
/**
 *
 * @export
 * @interface MetaOutput
 */
export interface MetaOutput {
  /**
   *
   * @type {number}
   * @memberof MetaOutput
   */
  page?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutput
   */
  limit?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutput
   */
  totalItems?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutput
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface MetaOutputJsonld
 */
export interface MetaOutputJsonld {
  /**
   *
   * @type {number}
   * @memberof MetaOutputJsonld
   */
  page?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutputJsonld
   */
  limit?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutputJsonld
   */
  totalItems?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutputJsonld
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface MetaOutputMultipart
 */
export interface MetaOutputMultipart {
  /**
   *
   * @type {number}
   * @memberof MetaOutputMultipart
   */
  page?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutputMultipart
   */
  limit?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutputMultipart
   */
  totalItems?: number;
  /**
   *
   * @type {number}
   * @memberof MetaOutputMultipart
   */
  totalPages?: number;
}
/**
 * A representation of common errors.
 * @export
 * @interface ModelError
 */
export interface ModelError {
  /**
   * A short, human-readable summary of the problem.
   * @type {string}
   * @memberof ModelError
   */
  title?: string | null;
  /**
   * A human-readable explanation specific to this occurrence of the problem.
   * @type {string}
   * @memberof ModelError
   */
  detail?: string | null;
  /**
   *
   * @type {number}
   * @memberof ModelError
   */
  status?: number | null;
  /**
   * A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.
   * @type {string}
   * @memberof ModelError
   */
  instance?: string | null;
  /**
   * A URI reference that identifies the problem type
   * @type {string}
   * @memberof ModelError
   */
  type?: string;
}
/**
 * valid values for Permissions
 * @export
 * @enum {string}
 */

export const Permissions = {
  CanViewMarketComponent: "CAN_VIEW_MARKET_COMPONENT",
  CanCreateMarketComponent: "CAN_CREATE_MARKET_COMPONENT",
  CanEditMarketComponent: "CAN_EDIT_MARKET_COMPONENT",
  CanViewCategory: "CAN_VIEW_CATEGORY",
  CanCreateCategory: "CAN_CREATE_CATEGORY",
  CanEditCategory: "CAN_EDIT_CATEGORY",
  CanViewUser: "CAN_VIEW_USER",
  CanEditUser: "CAN_EDIT_USER",
  CanEditStatusOfMarketComponent: "CAN_EDIT_STATUS_OF_MARKET_COMPONENT",
  CanViewMarketComponentHistory: "CAN_VIEW_MARKET_COMPONENT_HISTORY",
  CanViewProfile: "CAN_VIEW_PROFILE",
  CanViewMarket: "CAN_VIEW_MARKET",
  CanCreateMarket: "CAN_CREATE_MARKET",
  CanEditMarket: "CAN_EDIT_MARKET",
  CanDeleteMarketComponent: "CAN_DELETE_MARKET_COMPONENT",
  CanReadFile: "CAN_READ_FILE",
  CanUploadFile: "CAN_UPLOAD_FILE",
  CanViewReporting: "CAN_VIEW_REPORTING",
  CanExportReport: "CAN_EXPORT_REPORT",
} as const;

export type Permissions = (typeof Permissions)[keyof typeof Permissions];

/**
 *
 * @export
 * @interface PositionOutput
 */
export interface PositionOutput {
  /**
   *
   * @type {number}
   * @memberof PositionOutput
   */
  x?: number;
  /**
   *
   * @type {number}
   * @memberof PositionOutput
   */
  y?: number;
}
/**
 *
 * @export
 * @interface PositionOutputJsonld
 */
export interface PositionOutputJsonld {
  /**
   *
   * @type {number}
   * @memberof PositionOutputJsonld
   */
  x?: number;
  /**
   *
   * @type {number}
   * @memberof PositionOutputJsonld
   */
  y?: number;
}
/**
 *
 * @export
 * @interface PositionOutputMultipart
 */
export interface PositionOutputMultipart {
  /**
   *
   * @type {number}
   * @memberof PositionOutputMultipart
   */
  x?: number;
  /**
   *
   * @type {number}
   * @memberof PositionOutputMultipart
   */
  y?: number;
}
/**
 * valid values for Report
 * @export
 * @enum {string}
 */

export const Report = {
  MarketComponentHistory: "MARKET_COMPONENT_HISTORY",
  MarketComponent306090Verification: "MARKET_COMPONENT_30_60_90_VERIFICATION",
  MarketComponentWithoutCriticalBbd: "MARKET_COMPONENT_WITHOUT_CRITICAL_BBD",
  MarketComponentWhereShortDescriptionNotEqualsNumber:
    "MARKET_COMPONENT_WHERE_SHORT_DESCRIPTION_NOT_EQUALS_NUMBER",
  User: "USER",
} as const;

export type Report = (typeof Report)[keyof typeof Report];

/**
 *
 * @export
 * @interface ReportingJsonld
 */
export interface ReportingJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof ReportingJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof ReportingJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof ReportingJsonld
   */
  "@type": string;
}
/**
 *
 * @export
 * @interface ReportingMarketComponentHistoryOutput
 */
export interface ReportingMarketComponentHistoryOutput {
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  market?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  marketComponentName?: string;
  /**
   *
   * @type {number}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  marketComponentNumber?: number | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  criticalDate?: string | null;
  /**
   *
   * @type {MetaOutput}
   * @memberof ReportingMarketComponentHistoryOutput
   */
  metaOutput?: MetaOutput | null;
}
/**
 *
 * @export
 * @interface ReportingMarketComponentHistoryOutputJsonld
 */
export interface ReportingMarketComponentHistoryOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  market?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  marketComponentName?: string;
  /**
   *
   * @type {number}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  marketComponentNumber?: number | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  date?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  criticalDate?: string | null;
  /**
   *
   * @type {MetaOutputJsonld}
   * @memberof ReportingMarketComponentHistoryOutputJsonld
   */
  metaOutput?: MetaOutputJsonld | null;
}
/**
 *
 * @export
 * @interface ReportingMarketComponentOutput
 */
export interface ReportingMarketComponentOutput {
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  articleType?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  marketName?: string;
  /**
   *
   * @type {number}
   * @memberof ReportingMarketComponentOutput
   */
  number?: number | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  created?: string | null;
  /**
   *
   * @type {MetaOutput}
   * @memberof ReportingMarketComponentOutput
   */
  metaOutput?: MetaOutput | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutput
   */
  marketComponentStatus?: ReportingMarketComponentOutputMarketComponentStatusEnum;
}

export const ReportingMarketComponentOutputMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type ReportingMarketComponentOutputMarketComponentStatusEnum =
  (typeof ReportingMarketComponentOutputMarketComponentStatusEnum)[keyof typeof ReportingMarketComponentOutputMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface ReportingMarketComponentOutputJsonld
 */
export interface ReportingMarketComponentOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  shortDescription?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  articleType?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  marketName?: string;
  /**
   *
   * @type {number}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  number?: number | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  lastValidation?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  created?: string | null;
  /**
   *
   * @type {MetaOutputJsonld}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  metaOutput?: MetaOutputJsonld | null;
  /**
   *
   * @type {string}
   * @memberof ReportingMarketComponentOutputJsonld
   */
  marketComponentStatus?: ReportingMarketComponentOutputJsonldMarketComponentStatusEnum;
}

export const ReportingMarketComponentOutputJsonldMarketComponentStatusEnum = {
  _45b33f: "#45b33f",
  _00B28B: "#00B28B",
  Eaed00: "#eaed00",
  Cd0404: "#cd0404",
  Ffffff: "#FFFFFF",
  _252525: "#252525",
} as const;

export type ReportingMarketComponentOutputJsonldMarketComponentStatusEnum =
  (typeof ReportingMarketComponentOutputJsonldMarketComponentStatusEnum)[keyof typeof ReportingMarketComponentOutputJsonldMarketComponentStatusEnum];

/**
 *
 * @export
 * @interface ReportingUserOutput
 */
export interface ReportingUserOutput {
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutput
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutput
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutput
   */
  lastname?: string;
  /**
   *
   * @type {number}
   * @memberof ReportingUserOutput
   */
  checkCount?: number;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutput
   */
  deactivated?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutput
   */
  deactivatedBy?: string | null;
  /**
   *
   * @type {MetaOutput}
   * @memberof ReportingUserOutput
   */
  metaOutput?: MetaOutput | null;
}
/**
 *
 * @export
 * @interface ReportingUserOutputJsonld
 */
export interface ReportingUserOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof ReportingUserOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  lastname?: string;
  /**
   *
   * @type {number}
   * @memberof ReportingUserOutputJsonld
   */
  checkCount?: number;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  deactivated?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReportingUserOutputJsonld
   */
  deactivatedBy?: string | null;
  /**
   *
   * @type {MetaOutputJsonld}
   * @memberof ReportingUserOutputJsonld
   */
  metaOutput?: MetaOutputJsonld | null;
}
/**
 * valid values for Role
 * @export
 * @enum {string}
 */

export const Roles = {
  RoleUser: "ROLE_USER",
  RoleSupervisor: "ROLE_SUPERVISOR",
  RoleAdmin: "ROLE_ADMIN",
} as const;

export type Roles = (typeof Roles)[keyof typeof Roles];

/**
 * valid values for Rule
 * @export
 * @enum {string}
 */

export const Rule = {
  IfOlderThanXDays: "IF_OLDER_THAN_X_DAYS",
  DaysBeforeSwitchToRed: "DAYS_BEFORE_SWITCH_TO_RED",
  IfOlderThanDate: "IF_OLDER_THAN_DATE",
} as const;

export type Rule = (typeof Rule)[keyof typeof Rule];

/**
 *
 * @export
 * @interface SizeOutput
 */
export interface SizeOutput {
  /**
   *
   * @type {number}
   * @memberof SizeOutput
   */
  height?: number;
  /**
   *
   * @type {number}
   * @memberof SizeOutput
   */
  width?: number;
}
/**
 *
 * @export
 * @interface SizeOutputJsonld
 */
export interface SizeOutputJsonld {
  /**
   *
   * @type {number}
   * @memberof SizeOutputJsonld
   */
  height?: number;
  /**
   *
   * @type {number}
   * @memberof SizeOutputJsonld
   */
  width?: number;
}
/**
 *
 * @export
 * @interface SizeOutputMultipart
 */
export interface SizeOutputMultipart {
  /**
   *
   * @type {number}
   * @memberof SizeOutputMultipart
   */
  height?: number;
  /**
   *
   * @type {number}
   * @memberof SizeOutputMultipart
   */
  width?: number;
}
/**
 *
 * @export
 * @interface UserMarketsSuccessOutput
 */
export interface UserMarketsSuccessOutput {
  /**
   *
   * @type {string}
   * @memberof UserMarketsSuccessOutput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof UserMarketsSuccessOutput
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface UserMarketsSuccessOutputJsonld
 */
export interface UserMarketsSuccessOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof UserMarketsSuccessOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof UserMarketsSuccessOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof UserMarketsSuccessOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof UserMarketsSuccessOutputJsonld
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof UserMarketsSuccessOutputJsonld
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface UserMarketsUserMarketsIO
 */
export interface UserMarketsUserMarketsIO {
  /**
   *
   * @type {string}
   * @memberof UserMarketsUserMarketsIO
   */
  username?: string;
  /**
   *
   * @type {Array<MarketIOLight>}
   * @memberof UserMarketsUserMarketsIO
   */
  markets?: Array<MarketIOLight>;
}
/**
 *
 * @export
 * @interface UserMarketsUserMarketsIOJsonld
 */
export interface UserMarketsUserMarketsIOJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof UserMarketsUserMarketsIOJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof UserMarketsUserMarketsIOJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof UserMarketsUserMarketsIOJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof UserMarketsUserMarketsIOJsonld
   */
  username?: string;
  /**
   *
   * @type {Array<MarketIOLightJsonld>}
   * @memberof UserMarketsUserMarketsIOJsonld
   */
  markets?: Array<MarketIOLightJsonld>;
}
/**
 *
 * @export
 * @interface UserProfileProfileOutput
 */
export interface UserProfileProfileOutput {
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutput
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutput
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutput
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutput
   */
  languageCode?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UserProfileProfileOutput
   */
  roles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UserProfileProfileOutput
   */
  permissions?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutput
   */
  email?: string | null;
}
/**
 *
 * @export
 * @interface UserProfileProfileOutputJsonld
 */
export interface UserProfileProfileOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof UserProfileProfileOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  languageCode?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UserProfileProfileOutputJsonld
   */
  roles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UserProfileProfileOutputJsonld
   */
  permissions?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof UserProfileProfileOutputJsonld
   */
  email?: string | null;
}
/**
 *
 * @export
 * @interface UserSuccessOutput
 */
export interface UserSuccessOutput {
  /**
   *
   * @type {string}
   * @memberof UserSuccessOutput
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof UserSuccessOutput
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface UserSuccessOutputJsonld
 */
export interface UserSuccessOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof UserSuccessOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof UserSuccessOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof UserSuccessOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof UserSuccessOutputJsonld
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof UserSuccessOutputJsonld
   */
  details?: string | null;
}
/**
 *
 * @export
 * @interface UserUserDeactivateActivateInput
 */
export interface UserUserDeactivateActivateInput {
  /**
   *
   * @type {Array<string>}
   * @memberof UserUserDeactivateActivateInput
   */
  usersForDeactivation?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UserUserDeactivateActivateInput
   */
  usersForActivation?: Array<string>;
}
/**
 *
 * @export
 * @interface UserUserIO
 */
export interface UserUserIO {
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  languageCode?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UserUserIO
   */
  roles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UserUserIO
   */
  permissions?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  password?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  deactivated?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  deactivatedBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIO
   */
  markets?: string | null;
}
/**
 *
 * @export
 * @interface UserUserIOJsonld
 */
export interface UserUserIOJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof UserUserIOJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  firstname?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  lastname?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  languageCode?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof UserUserIOJsonld
   */
  roles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof UserUserIOJsonld
   */
  permissions?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  password?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  deactivated?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  deactivatedBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserUserIOJsonld
   */
  markets?: string | null;
}
/**
 *
 * @export
 * @interface UserUserResetPasswordInput
 */
export interface UserUserResetPasswordInput {
  /**
   *
   * @type {string}
   * @memberof UserUserResetPasswordInput
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof UserUserResetPasswordInput
   */
  newPassword?: string;
}
/**
 *
 * @export
 * @interface VersionVersionOutput
 */
export interface VersionVersionOutput {
  /**
   *
   * @type {string}
   * @memberof VersionVersionOutput
   */
  version?: string;
}
/**
 *
 * @export
 * @interface VersionVersionOutputJsonld
 */
export interface VersionVersionOutputJsonld {
  /**
   *
   * @type {HydraItemBaseSchemaContext}
   * @memberof VersionVersionOutputJsonld
   */
  "@context"?: HydraItemBaseSchemaContext;
  /**
   *
   * @type {string}
   * @memberof VersionVersionOutputJsonld
   */
  "@id": string;
  /**
   *
   * @type {string}
   * @memberof VersionVersionOutputJsonld
   */
  "@type": string;
  /**
   *
   * @type {string}
   * @memberof VersionVersionOutputJsonld
   */
  version?: string;
}

/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a File resource.
     * @summary Creates a File resource.
     * @param {string} target File identifier
     * @param {string} entityId File identifier
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFileTargetEntityIdPost: async (
      target: string,
      entityId: string,
      file?: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'target' is not null or undefined
      assertParamExists("apiFileTargetEntityIdPost", "target", target);
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists("apiFileTargetEntityIdPost", "entityId", entityId);
      const localVarPath = `/api/file/{target}/{entityId}`
        .replace(`{${"target"}}`, encodeURIComponent(String(target)))
        .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new (
        (configuration && configuration.formDataCtor) ||
        FormData
      )();

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append("file", file as any);
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a File resource.
     * @summary Retrieves a File resource.
     * @param {string} target File identifier
     * @param {string} filename File identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFileTargetFilenameGet: async (
      target: string,
      filename: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'target' is not null or undefined
      assertParamExists("apiFileTargetFilenameGet", "target", target);
      // verify required parameter 'filename' is not null or undefined
      assertParamExists("apiFileTargetFilenameGet", "filename", filename);
      const localVarPath = `/api/file/{target}/{filename}`
        .replace(`{${"target"}}`, encodeURIComponent(String(target)))
        .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a File resource.
     * @summary Creates a File resource.
     * @param {string} target File identifier
     * @param {string} entityId File identifier
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFileTargetEntityIdPost(
      target: string,
      entityId: string,
      file?: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<FileSuccessOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFileTargetEntityIdPost(
          target,
          entityId,
          file,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["FileApi.apiFileTargetEntityIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves a File resource.
     * @summary Retrieves a File resource.
     * @param {string} target File identifier
     * @param {string} filename File identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFileTargetFilenameGet(
      target: string,
      filename: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFileTargetFilenameGet(
          target,
          filename,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["FileApi.apiFileTargetFilenameGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FileApiFp(configuration);
  return {
    /**
     * Creates a File resource.
     * @summary Creates a File resource.
     * @param {string} target File identifier
     * @param {string} entityId File identifier
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFileTargetEntityIdPost(
      target: string,
      entityId: string,
      file?: File,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FileSuccessOutput> {
      return localVarFp
        .apiFileTargetEntityIdPost(target, entityId, file, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a File resource.
     * @summary Retrieves a File resource.
     * @param {string} target File identifier
     * @param {string} filename File identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFileTargetFilenameGet(
      target: string,
      filename: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .apiFileTargetFilenameGet(target, filename, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
  /**
   * Creates a File resource.
   * @summary Creates a File resource.
   * @param {string} target File identifier
   * @param {string} entityId File identifier
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */
  public apiFileTargetEntityIdPost(
    target: string,
    entityId: string,
    file?: File,
    options?: RawAxiosRequestConfig,
  ) {
    return FileApiFp(this.configuration)
      .apiFileTargetEntityIdPost(target, entityId, file, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a File resource.
   * @summary Retrieves a File resource.
   * @param {string} target File identifier
   * @param {string} filename File identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */
  public apiFileTargetFilenameGet(
    target: string,
    filename: string,
    options?: RawAxiosRequestConfig,
  ) {
    return FileApiFp(this.configuration)
      .apiFileTargetFilenameGet(target, filename, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * LoggingApi - axios parameter creator
 * @export
 */
export const LoggingApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a Logging resource.
     * @summary Creates a Logging resource.
     * @param {LoggingLoggingInput} loggingLoggingInput The new Logging resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiLoggingPost: async (
      loggingLoggingInput: LoggingLoggingInput,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'loggingLoggingInput' is not null or undefined
      assertParamExists(
        "apiLoggingPost",
        "loggingLoggingInput",
        loggingLoggingInput,
      );
      const localVarPath = `/api/logging`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        loggingLoggingInput,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LoggingApi - functional programming interface
 * @export
 */
export const LoggingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LoggingApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a Logging resource.
     * @summary Creates a Logging resource.
     * @param {LoggingLoggingInput} loggingLoggingInput The new Logging resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiLoggingPost(
      loggingLoggingInput: LoggingLoggingInput,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LoggingSuccessOutput>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiLoggingPost(
        loggingLoggingInput,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LoggingApi.apiLoggingPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * LoggingApi - factory interface
 * @export
 */
export const LoggingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LoggingApiFp(configuration);
  return {
    /**
     * Creates a Logging resource.
     * @summary Creates a Logging resource.
     * @param {LoggingLoggingInput} loggingLoggingInput The new Logging resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiLoggingPost(
      loggingLoggingInput: LoggingLoggingInput,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LoggingSuccessOutput> {
      return localVarFp
        .apiLoggingPost(loggingLoggingInput, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * LoggingApi - object-oriented interface
 * @export
 * @class LoggingApi
 * @extends {BaseAPI}
 */
export class LoggingApi extends BaseAPI {
  /**
   * Creates a Logging resource.
   * @summary Creates a Logging resource.
   * @param {LoggingLoggingInput} loggingLoggingInput The new Logging resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LoggingApi
   */
  public apiLoggingPost(
    loggingLoggingInput: LoggingLoggingInput,
    options?: RawAxiosRequestConfig,
  ) {
    return LoggingApiFp(this.configuration)
      .apiLoggingPost(loggingLoggingInput, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * LoginCheckApi - axios parameter creator
 * @export
 */
export const LoginCheckApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a user token.
     * @summary Creates a user token.
     * @param {LoginCheckPostRequest} loginCheckPostRequest The login data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCheckPost: async (
      loginCheckPostRequest: LoginCheckPostRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'loginCheckPostRequest' is not null or undefined
      assertParamExists(
        "loginCheckPost",
        "loginCheckPostRequest",
        loginCheckPostRequest,
      );
      const localVarPath = `/auth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        loginCheckPostRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LoginCheckApi - functional programming interface
 * @export
 */
export const LoginCheckApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    LoginCheckApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a user token.
     * @summary Creates a user token.
     * @param {LoginCheckPostRequest} loginCheckPostRequest The login data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loginCheckPost(
      loginCheckPostRequest: LoginCheckPostRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LoginCheckPost200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.loginCheckPost(
        loginCheckPostRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LoginCheckApi.loginCheckPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * LoginCheckApi - factory interface
 * @export
 */
export const LoginCheckApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LoginCheckApiFp(configuration);
  return {
    /**
     * Creates a user token.
     * @summary Creates a user token.
     * @param {LoginCheckPostRequest} loginCheckPostRequest The login data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCheckPost(
      loginCheckPostRequest: LoginCheckPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LoginCheckPost200Response> {
      return localVarFp
        .loginCheckPost(loginCheckPostRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * LoginCheckApi - object-oriented interface
 * @export
 * @class LoginCheckApi
 * @extends {BaseAPI}
 */
export class LoginCheckApi extends BaseAPI {
  /**
   * Creates a user token.
   * @summary Creates a user token.
   * @param {LoginCheckPostRequest} loginCheckPostRequest The login data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LoginCheckApi
   */
  public loginCheckPost(
    loginCheckPostRequest: LoginCheckPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LoginCheckApiFp(this.configuration)
      .loginCheckPost(loginCheckPostRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * LogoutApi - axios parameter creator
 * @export
 */
export const LogoutApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a Logout resource.
     * @summary Creates a Logout resource.
     * @param {object} body The new Logout resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiLogoutPost: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists("apiLogoutPost", "body", body);
      const localVarPath = `/api/logout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * LogoutApi - functional programming interface
 * @export
 */
export const LogoutApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LogoutApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a Logout resource.
     * @summary Creates a Logout resource.
     * @param {object} body The new Logout resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiLogoutPost(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LogoutSuccessOutput>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogoutPost(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["LogoutApi.apiLogoutPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * LogoutApi - factory interface
 * @export
 */
export const LogoutApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LogoutApiFp(configuration);
  return {
    /**
     * Creates a Logout resource.
     * @summary Creates a Logout resource.
     * @param {object} body The new Logout resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiLogoutPost(
      body: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LogoutSuccessOutput> {
      return localVarFp
        .apiLogoutPost(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * LogoutApi - object-oriented interface
 * @export
 * @class LogoutApi
 * @extends {BaseAPI}
 */
export class LogoutApi extends BaseAPI {
  /**
   * Creates a Logout resource.
   * @summary Creates a Logout resource.
   * @param {object} body The new Logout resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LogoutApi
   */
  public apiLogoutPost(body: object, options?: RawAxiosRequestConfig) {
    return LogoutApiFp(this.configuration)
      .apiLogoutPost(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MarketApi - axios parameter creator
 * @export
 */
export const MarketApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a Market resource.
     * @summary Creates a Market resource.
     * @param {MarketMarketIO} marketMarketIO The new Market resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketPost: async (
      marketMarketIO: MarketMarketIO,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketMarketIO' is not null or undefined
      assertParamExists("apiMarketPost", "marketMarketIO", marketMarketIO);
      const localVarPath = `/api/market`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        marketMarketIO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Market resources.
     * @summary Retrieves the collection of Market resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketsGetCollection: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/markets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarketApi - functional programming interface
 * @export
 */
export const MarketApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MarketApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a Market resource.
     * @summary Creates a Market resource.
     * @param {MarketMarketIO} marketMarketIO The new Market resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketPost(
      marketMarketIO: MarketMarketIO,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketMarketIO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiMarketPost(
        marketMarketIO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MarketApi.apiMarketPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of Market resources.
     * @summary Retrieves the collection of Market resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketsGetCollection(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MarketMarketIO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketsGetCollection(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MarketApi.apiMarketsGetCollection"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MarketApi - factory interface
 * @export
 */
export const MarketApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MarketApiFp(configuration);
  return {
    /**
     * Creates a Market resource.
     * @summary Creates a Market resource.
     * @param {MarketMarketIO} marketMarketIO The new Market resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketPost(
      marketMarketIO: MarketMarketIO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MarketMarketIO> {
      return localVarFp
        .apiMarketPost(marketMarketIO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Market resources.
     * @summary Retrieves the collection of Market resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketsGetCollection(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MarketMarketIO>> {
      return localVarFp
        .apiMarketsGetCollection(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MarketApi - object-oriented interface
 * @export
 * @class MarketApi
 * @extends {BaseAPI}
 */
export class MarketApi extends BaseAPI {
  /**
   * Creates a Market resource.
   * @summary Creates a Market resource.
   * @param {MarketMarketIO} marketMarketIO The new Market resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketApi
   */
  public apiMarketPost(
    marketMarketIO: MarketMarketIO,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketApiFp(this.configuration)
      .apiMarketPost(marketMarketIO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Market resources.
   * @summary Retrieves the collection of Market resources.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketApi
   */
  public apiMarketsGetCollection(options?: RawAxiosRequestConfig) {
    return MarketApiFp(this.configuration)
      .apiMarketsGetCollection(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MarketComponentApi - axios parameter creator
 * @export
 */
export const MarketComponentApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of Market Component resources.
     * @summary Retrieves the collection of Market Component resources.
     * @param {string} marketId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsForValidationMarketIdGetCollection: async (
      marketId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketId' is not null or undefined
      assertParamExists(
        "apiMarketComponentsForValidationMarketIdGetCollection",
        "marketId",
        marketId,
      );
      const localVarPath =
        `/api/market_components_for_validation/{marketId}`.replace(
          `{${"marketId"}}`,
          encodeURIComponent(String(marketId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Removes the Market Component resource.
     * @summary Removes the Market Component resource.
     * @param {string} marketComponentId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsMarketComponentIdDelete: async (
      marketComponentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketComponentId' is not null or undefined
      assertParamExists(
        "apiMarketComponentsMarketComponentIdDelete",
        "marketComponentId",
        marketComponentId,
      );
      const localVarPath = `/api/market_components/{marketComponentId}`.replace(
        `{${"marketComponentId"}}`,
        encodeURIComponent(String(marketComponentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the Market Component resource.
     * @summary Replaces the Market Component resource.
     * @param {string} marketComponentId Market Component identifier
     * @param {MarketComponentMarketComponentStatusDateInput} marketComponentMarketComponentStatusDateInput The updated Market Component resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsMarketComponentIdPut: async (
      marketComponentId: string,
      marketComponentMarketComponentStatusDateInput: MarketComponentMarketComponentStatusDateInput,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketComponentId' is not null or undefined
      assertParamExists(
        "apiMarketComponentsMarketComponentIdPut",
        "marketComponentId",
        marketComponentId,
      );
      // verify required parameter 'marketComponentMarketComponentStatusDateInput' is not null or undefined
      assertParamExists(
        "apiMarketComponentsMarketComponentIdPut",
        "marketComponentMarketComponentStatusDateInput",
        marketComponentMarketComponentStatusDateInput,
      );
      const localVarPath = `/api/market_components/{marketComponentId}`.replace(
        `{${"marketComponentId"}}`,
        encodeURIComponent(String(marketComponentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        marketComponentMarketComponentStatusDateInput,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Market Component resources.
     * @summary Retrieves the collection of Market Component resources.
     * @param {string} marketId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsMarketIdGetCollection: async (
      marketId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketId' is not null or undefined
      assertParamExists(
        "apiMarketComponentsMarketIdGetCollection",
        "marketId",
        marketId,
      );
      const localVarPath = `/api/market_components/{marketId}`.replace(
        `{${"marketId"}}`,
        encodeURIComponent(String(marketId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a Market Component resource.
     * @summary Creates a Market Component resource.
     * @param {MarketComponentMarketComponentCollectionIO} marketComponentMarketComponentCollectionIO The new Market Component resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsPost: async (
      marketComponentMarketComponentCollectionIO: MarketComponentMarketComponentCollectionIO,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketComponentMarketComponentCollectionIO' is not null or undefined
      assertParamExists(
        "apiMarketComponentsPost",
        "marketComponentMarketComponentCollectionIO",
        marketComponentMarketComponentCollectionIO,
      );
      const localVarPath = `/api/market_components`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        marketComponentMarketComponentCollectionIO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarketComponentApi - functional programming interface
 * @export
 */
export const MarketComponentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MarketComponentApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of Market Component resources.
     * @summary Retrieves the collection of Market Component resources.
     * @param {string} marketId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentsForValidationMarketIdGetCollection(
      marketId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MarketComponentMarketComponentIO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentsForValidationMarketIdGetCollection(
          marketId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentApi.apiMarketComponentsForValidationMarketIdGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Removes the Market Component resource.
     * @summary Removes the Market Component resource.
     * @param {string} marketComponentId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentsMarketComponentIdDelete(
      marketComponentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentsMarketComponentIdDelete(
          marketComponentId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentApi.apiMarketComponentsMarketComponentIdDelete"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Replaces the Market Component resource.
     * @summary Replaces the Market Component resource.
     * @param {string} marketComponentId Market Component identifier
     * @param {MarketComponentMarketComponentStatusDateInput} marketComponentMarketComponentStatusDateInput The updated Market Component resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentsMarketComponentIdPut(
      marketComponentId: string,
      marketComponentMarketComponentStatusDateInput: MarketComponentMarketComponentStatusDateInput,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MarketComponentSuccessOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentsMarketComponentIdPut(
          marketComponentId,
          marketComponentMarketComponentStatusDateInput,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentApi.apiMarketComponentsMarketComponentIdPut"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of Market Component resources.
     * @summary Retrieves the collection of Market Component resources.
     * @param {string} marketId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentsMarketIdGetCollection(
      marketId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MarketComponentMarketComponentIO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentsMarketIdGetCollection(
          marketId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentApi.apiMarketComponentsMarketIdGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Creates a Market Component resource.
     * @summary Creates a Market Component resource.
     * @param {MarketComponentMarketComponentCollectionIO} marketComponentMarketComponentCollectionIO The new Market Component resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentsPost(
      marketComponentMarketComponentCollectionIO: MarketComponentMarketComponentCollectionIO,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MarketComponentMarketComponentCollectionIO>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentsPost(
          marketComponentMarketComponentCollectionIO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["MarketComponentApi.apiMarketComponentsPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MarketComponentApi - factory interface
 * @export
 */
export const MarketComponentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MarketComponentApiFp(configuration);
  return {
    /**
     * Retrieves the collection of Market Component resources.
     * @summary Retrieves the collection of Market Component resources.
     * @param {string} marketId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsForValidationMarketIdGetCollection(
      marketId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MarketComponentMarketComponentIO>> {
      return localVarFp
        .apiMarketComponentsForValidationMarketIdGetCollection(
          marketId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Removes the Market Component resource.
     * @summary Removes the Market Component resource.
     * @param {string} marketComponentId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsMarketComponentIdDelete(
      marketComponentId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .apiMarketComponentsMarketComponentIdDelete(marketComponentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the Market Component resource.
     * @summary Replaces the Market Component resource.
     * @param {string} marketComponentId Market Component identifier
     * @param {MarketComponentMarketComponentStatusDateInput} marketComponentMarketComponentStatusDateInput The updated Market Component resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsMarketComponentIdPut(
      marketComponentId: string,
      marketComponentMarketComponentStatusDateInput: MarketComponentMarketComponentStatusDateInput,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MarketComponentSuccessOutput> {
      return localVarFp
        .apiMarketComponentsMarketComponentIdPut(
          marketComponentId,
          marketComponentMarketComponentStatusDateInput,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Market Component resources.
     * @summary Retrieves the collection of Market Component resources.
     * @param {string} marketId Market Component identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsMarketIdGetCollection(
      marketId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MarketComponentMarketComponentIO>> {
      return localVarFp
        .apiMarketComponentsMarketIdGetCollection(marketId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates a Market Component resource.
     * @summary Creates a Market Component resource.
     * @param {MarketComponentMarketComponentCollectionIO} marketComponentMarketComponentCollectionIO The new Market Component resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentsPost(
      marketComponentMarketComponentCollectionIO: MarketComponentMarketComponentCollectionIO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<MarketComponentMarketComponentCollectionIO> {
      return localVarFp
        .apiMarketComponentsPost(
          marketComponentMarketComponentCollectionIO,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MarketComponentApi - object-oriented interface
 * @export
 * @class MarketComponentApi
 * @extends {BaseAPI}
 */
export class MarketComponentApi extends BaseAPI {
  /**
   * Retrieves the collection of Market Component resources.
   * @summary Retrieves the collection of Market Component resources.
   * @param {string} marketId Market Component identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentApi
   */
  public apiMarketComponentsForValidationMarketIdGetCollection(
    marketId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentApiFp(this.configuration)
      .apiMarketComponentsForValidationMarketIdGetCollection(marketId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Removes the Market Component resource.
   * @summary Removes the Market Component resource.
   * @param {string} marketComponentId Market Component identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentApi
   */
  public apiMarketComponentsMarketComponentIdDelete(
    marketComponentId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentApiFp(this.configuration)
      .apiMarketComponentsMarketComponentIdDelete(marketComponentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the Market Component resource.
   * @summary Replaces the Market Component resource.
   * @param {string} marketComponentId Market Component identifier
   * @param {MarketComponentMarketComponentStatusDateInput} marketComponentMarketComponentStatusDateInput The updated Market Component resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentApi
   */
  public apiMarketComponentsMarketComponentIdPut(
    marketComponentId: string,
    marketComponentMarketComponentStatusDateInput: MarketComponentMarketComponentStatusDateInput,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentApiFp(this.configuration)
      .apiMarketComponentsMarketComponentIdPut(
        marketComponentId,
        marketComponentMarketComponentStatusDateInput,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Market Component resources.
   * @summary Retrieves the collection of Market Component resources.
   * @param {string} marketId Market Component identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentApi
   */
  public apiMarketComponentsMarketIdGetCollection(
    marketId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentApiFp(this.configuration)
      .apiMarketComponentsMarketIdGetCollection(marketId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates a Market Component resource.
   * @summary Creates a Market Component resource.
   * @param {MarketComponentMarketComponentCollectionIO} marketComponentMarketComponentCollectionIO The new Market Component resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentApi
   */
  public apiMarketComponentsPost(
    marketComponentMarketComponentCollectionIO: MarketComponentMarketComponentCollectionIO,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentApiFp(this.configuration)
      .apiMarketComponentsPost(
        marketComponentMarketComponentCollectionIO,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MarketComponentArticleTypeApi - axios parameter creator
 * @export
 */
export const MarketComponentArticleTypeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of Market Component Article Type resources.
     * @summary Retrieves the collection of Market Component Article Type resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentArticleTypesGetCollection: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/market_component_article_types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarketComponentArticleTypeApi - functional programming interface
 * @export
 */
export const MarketComponentArticleTypeApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MarketComponentArticleTypeApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of Market Component Article Type resources.
     * @summary Retrieves the collection of Market Component Article Type resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentArticleTypesGetCollection(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<
        Array<MarketComponentArticleTypeMarketComponentArticleTypeOutput>
      >
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentArticleTypesGetCollection(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentArticleTypeApi.apiMarketComponentArticleTypesGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MarketComponentArticleTypeApi - factory interface
 * @export
 */
export const MarketComponentArticleTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MarketComponentArticleTypeApiFp(configuration);
  return {
    /**
     * Retrieves the collection of Market Component Article Type resources.
     * @summary Retrieves the collection of Market Component Article Type resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentArticleTypesGetCollection(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<
      Array<MarketComponentArticleTypeMarketComponentArticleTypeOutput>
    > {
      return localVarFp
        .apiMarketComponentArticleTypesGetCollection(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MarketComponentArticleTypeApi - object-oriented interface
 * @export
 * @class MarketComponentArticleTypeApi
 * @extends {BaseAPI}
 */
export class MarketComponentArticleTypeApi extends BaseAPI {
  /**
   * Retrieves the collection of Market Component Article Type resources.
   * @summary Retrieves the collection of Market Component Article Type resources.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentArticleTypeApi
   */
  public apiMarketComponentArticleTypesGetCollection(
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentArticleTypeApiFp(this.configuration)
      .apiMarketComponentArticleTypesGetCollection(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MarketComponentHistoryApi - axios parameter creator
 * @export
 */
export const MarketComponentHistoryApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of Market Component History resources.
     * @summary Retrieves the collection of Market Component History resources.
     * @param {string} marketComponentId Market Component History identifier
     * @param {number} [page] The collection page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection:
      async (
        marketComponentId: string,
        page?: number,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'marketComponentId' is not null or undefined
        assertParamExists(
          "apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection",
          "marketComponentId",
          marketComponentId,
        );
        const localVarPath =
          `/api/market_component_historie/market_component/{marketComponentId}`.replace(
            `{${"marketComponentId"}}`,
            encodeURIComponent(String(marketComponentId)),
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication JWT required
        // http bearer authentication required
        await setBearerAuthToObject(localVarHeaderParameter, configuration);

        if (page !== undefined) {
          localVarQueryParameter["page"] = page;
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Retrieves the collection of Market Component History resources.
     * @summary Retrieves the collection of Market Component History resources.
     * @param {string} marketId Market Component History identifier
     * @param {number} [page] The collection page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentHistoriemarketMarketIdGetCollection: async (
      marketId: string,
      page?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'marketId' is not null or undefined
      assertParamExists(
        "apiMarketComponentHistoriemarketMarketIdGetCollection",
        "marketId",
        marketId,
      );
      const localVarPath =
        `/api/market_component_historie/market/{marketId}`.replace(
          `{${"marketId"}}`,
          encodeURIComponent(String(marketId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarketComponentHistoryApi - functional programming interface
 * @export
 */
export const MarketComponentHistoryApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MarketComponentHistoryApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of Market Component History resources.
     * @summary Retrieves the collection of Market Component History resources.
     * @param {string} marketComponentId Market Component History identifier
     * @param {number} [page] The collection page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
      marketComponentId: string,
      page?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<
        Array<MarketComponentHistoryMarketComponentHistoryOutput>
      >
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
          marketComponentId,
          page,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentHistoryApi.apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of Market Component History resources.
     * @summary Retrieves the collection of Market Component History resources.
     * @param {string} marketId Market Component History identifier
     * @param {number} [page] The collection page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentHistoriemarketMarketIdGetCollection(
      marketId: string,
      page?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<
        Array<MarketComponentHistoryMarketComponentHistoryOutput>
      >
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentHistoriemarketMarketIdGetCollection(
          marketId,
          page,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentHistoryApi.apiMarketComponentHistoriemarketMarketIdGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MarketComponentHistoryApi - factory interface
 * @export
 */
export const MarketComponentHistoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MarketComponentHistoryApiFp(configuration);
  return {
    /**
     * Retrieves the collection of Market Component History resources.
     * @summary Retrieves the collection of Market Component History resources.
     * @param {string} marketComponentId Market Component History identifier
     * @param {number} [page] The collection page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
      marketComponentId: string,
      page?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MarketComponentHistoryMarketComponentHistoryOutput>> {
      return localVarFp
        .apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
          marketComponentId,
          page,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Market Component History resources.
     * @summary Retrieves the collection of Market Component History resources.
     * @param {string} marketId Market Component History identifier
     * @param {number} [page] The collection page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentHistoriemarketMarketIdGetCollection(
      marketId: string,
      page?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MarketComponentHistoryMarketComponentHistoryOutput>> {
      return localVarFp
        .apiMarketComponentHistoriemarketMarketIdGetCollection(
          marketId,
          page,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MarketComponentHistoryApi - object-oriented interface
 * @export
 * @class MarketComponentHistoryApi
 * @extends {BaseAPI}
 */
export class MarketComponentHistoryApi extends BaseAPI {
  /**
   * Retrieves the collection of Market Component History resources.
   * @summary Retrieves the collection of Market Component History resources.
   * @param {string} marketComponentId Market Component History identifier
   * @param {number} [page] The collection page number
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentHistoryApi
   */
  public apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
    marketComponentId: string,
    page?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentHistoryApiFp(this.configuration)
      .apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
        marketComponentId,
        page,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Market Component History resources.
   * @summary Retrieves the collection of Market Component History resources.
   * @param {string} marketId Market Component History identifier
   * @param {number} [page] The collection page number
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentHistoryApi
   */
  public apiMarketComponentHistoriemarketMarketIdGetCollection(
    marketId: string,
    page?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MarketComponentHistoryApiFp(this.configuration)
      .apiMarketComponentHistoriemarketMarketIdGetCollection(
        marketId,
        page,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MarketComponentTypeApi - axios parameter creator
 * @export
 */
export const MarketComponentTypeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves the collection of Market Component Type resources.
     * @summary Retrieves the collection of Market Component Type resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentTypesGetCollection: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/market_component_types`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MarketComponentTypeApi - functional programming interface
 * @export
 */
export const MarketComponentTypeApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MarketComponentTypeApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves the collection of Market Component Type resources.
     * @summary Retrieves the collection of Market Component Type resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiMarketComponentTypesGetCollection(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MarketComponentTypeMarketComponentTypeOutput>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMarketComponentTypesGetCollection(
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "MarketComponentTypeApi.apiMarketComponentTypesGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MarketComponentTypeApi - factory interface
 * @export
 */
export const MarketComponentTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MarketComponentTypeApiFp(configuration);
  return {
    /**
     * Retrieves the collection of Market Component Type resources.
     * @summary Retrieves the collection of Market Component Type resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiMarketComponentTypesGetCollection(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<MarketComponentTypeMarketComponentTypeOutput>> {
      return localVarFp
        .apiMarketComponentTypesGetCollection(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MarketComponentTypeApi - object-oriented interface
 * @export
 * @class MarketComponentTypeApi
 * @extends {BaseAPI}
 */
export class MarketComponentTypeApi extends BaseAPI {
  /**
   * Retrieves the collection of Market Component Type resources.
   * @summary Retrieves the collection of Market Component Type resources.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MarketComponentTypeApi
   */
  public apiMarketComponentTypesGetCollection(options?: RawAxiosRequestConfig) {
    return MarketComponentTypeApiFp(this.configuration)
      .apiMarketComponentTypesGetCollection(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ReportingApi - axios parameter creator
 * @export
 */
export const ReportingApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves a Reporting resource.
     * @summary Retrieves a Reporting resource.
     * @param {string} report Reporting identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportingcsvExportReportGet: async (
      report: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'report' is not null or undefined
      assertParamExists("apiReportingcsvExportReportGet", "report", report);
      const localVarPath = `/api/reporting/csv_export/{report}`.replace(
        `{${"report"}}`,
        encodeURIComponent(String(report)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum} [orderMarketComponentMarketName]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum} [orderMarketComponentShortDescription]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum} [orderMarketComponentNumber]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum} [orderCreated]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum} [orderUserUsername]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum} [orderStatus]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum} [orderCriticalDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportingmarketComponentHistoryGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      orderMarketComponentMarketName?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum,
      orderMarketComponentShortDescription?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum,
      orderMarketComponentNumber?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum,
      orderCreated?: ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum,
      orderUserUsername?: ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum,
      orderStatus?: ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum,
      orderCriticalDate?: ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/reporting/market_component_history`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }

      if (orderMarketComponentMarketName !== undefined) {
        localVarQueryParameter["order[marketComponent.market.name]"] =
          orderMarketComponentMarketName;
      }

      if (orderMarketComponentShortDescription !== undefined) {
        localVarQueryParameter["order[marketComponent.shortDescription]"] =
          orderMarketComponentShortDescription;
      }

      if (orderMarketComponentNumber !== undefined) {
        localVarQueryParameter["order[marketComponent.number]"] =
          orderMarketComponentNumber;
      }

      if (orderCreated !== undefined) {
        localVarQueryParameter["order[created]"] = orderCreated;
      }

      if (orderUserUsername !== undefined) {
        localVarQueryParameter["order[user.username]"] = orderUserUsername;
      }

      if (orderStatus !== undefined) {
        localVarQueryParameter["order[status]"] = orderStatus;
      }

      if (orderCriticalDate !== undefined) {
        localVarQueryParameter["order[criticalDate]"] = orderCriticalDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {string} report Reporting identifier
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportingmarketComponentReportGetCollectionOrderNumberEnum} [orderNumber]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum} [orderCreated]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum} [orderShortDescription]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum} [orderDescription]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum} [orderMarketComponentArticleTypeName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum} [orderMarketComponentTypeName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum} [orderMarketName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum} [orderMarketComponentHistoriesCreated]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportingmarketComponentReportGetCollection: async (
      report: string,
      page?: number,
      itemsPerPage?: number,
      orderNumber?: ApiReportingmarketComponentReportGetCollectionOrderNumberEnum,
      orderCreated?: ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum,
      orderShortDescription?: ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum,
      orderDescription?: ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum,
      orderMarketComponentArticleTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum,
      orderMarketComponentTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum,
      orderMarketName?: ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum,
      orderMarketComponentHistoriesCreated?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'report' is not null or undefined
      assertParamExists(
        "apiReportingmarketComponentReportGetCollection",
        "report",
        report,
      );
      const localVarPath = `/api/reporting/market_component/{report}`.replace(
        `{${"report"}}`,
        encodeURIComponent(String(report)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }

      if (orderNumber !== undefined) {
        localVarQueryParameter["order[number]"] = orderNumber;
      }

      if (orderCreated !== undefined) {
        localVarQueryParameter["order[created]"] = orderCreated;
      }

      if (orderShortDescription !== undefined) {
        localVarQueryParameter["order[shortDescription]"] =
          orderShortDescription;
      }

      if (orderDescription !== undefined) {
        localVarQueryParameter["order[description]"] = orderDescription;
      }

      if (orderMarketComponentArticleTypeName !== undefined) {
        localVarQueryParameter["order[marketComponentArticleType.name]"] =
          orderMarketComponentArticleTypeName;
      }

      if (orderMarketComponentTypeName !== undefined) {
        localVarQueryParameter["order[marketComponentType.name]"] =
          orderMarketComponentTypeName;
      }

      if (orderMarketName !== undefined) {
        localVarQueryParameter["order[market.name]"] = orderMarketName;
      }

      if (orderMarketComponentHistoriesCreated !== undefined) {
        localVarQueryParameter["order[marketComponentHistories.created]"] =
          orderMarketComponentHistoriesCreated;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportinguserGetCollectionOrderUsernameEnum} [orderUsername]
     * @param {ApiReportinguserGetCollectionOrderFirstnameEnum} [orderFirstname]
     * @param {ApiReportinguserGetCollectionOrderLastnameEnum} [orderLastname]
     * @param {ApiReportinguserGetCollectionOrderDeactivatedEnum} [orderDeactivated]
     * @param {ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum} [orderDeactivatedByUsername]
     * @param {ApiReportinguserGetCollectionOrderCheckCountEnum} [orderCheckCount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportinguserGetCollection: async (
      page?: number,
      itemsPerPage?: number,
      orderUsername?: ApiReportinguserGetCollectionOrderUsernameEnum,
      orderFirstname?: ApiReportinguserGetCollectionOrderFirstnameEnum,
      orderLastname?: ApiReportinguserGetCollectionOrderLastnameEnum,
      orderDeactivated?: ApiReportinguserGetCollectionOrderDeactivatedEnum,
      orderDeactivatedByUsername?: ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum,
      orderCheckCount?: ApiReportinguserGetCollectionOrderCheckCountEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/reporting/user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (itemsPerPage !== undefined) {
        localVarQueryParameter["itemsPerPage"] = itemsPerPage;
      }

      if (orderUsername !== undefined) {
        localVarQueryParameter["order[username]"] = orderUsername;
      }

      if (orderFirstname !== undefined) {
        localVarQueryParameter["order[firstname]"] = orderFirstname;
      }

      if (orderLastname !== undefined) {
        localVarQueryParameter["order[lastname]"] = orderLastname;
      }

      if (orderDeactivated !== undefined) {
        localVarQueryParameter["order[deactivated]"] = orderDeactivated;
      }

      if (orderDeactivatedByUsername !== undefined) {
        localVarQueryParameter["order[deactivatedBy.username]"] =
          orderDeactivatedByUsername;
      }

      if (orderCheckCount !== undefined) {
        localVarQueryParameter["order[checkCount]"] = orderCheckCount;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportingApi - functional programming interface
 * @export
 */
export const ReportingApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ReportingApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves a Reporting resource.
     * @summary Retrieves a Reporting resource.
     * @param {string} report Reporting identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportingcsvExportReportGet(
      report: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportingcsvExportReportGet(
          report,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportingApi.apiReportingcsvExportReportGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum} [orderMarketComponentMarketName]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum} [orderMarketComponentShortDescription]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum} [orderMarketComponentNumber]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum} [orderCreated]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum} [orderUserUsername]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum} [orderStatus]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum} [orderCriticalDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportingmarketComponentHistoryGetCollection(
      page?: number,
      itemsPerPage?: number,
      orderMarketComponentMarketName?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum,
      orderMarketComponentShortDescription?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum,
      orderMarketComponentNumber?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum,
      orderCreated?: ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum,
      orderUserUsername?: ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum,
      orderStatus?: ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum,
      orderCriticalDate?: ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ReportingMarketComponentHistoryOutput>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportingmarketComponentHistoryGetCollection(
          page,
          itemsPerPage,
          orderMarketComponentMarketName,
          orderMarketComponentShortDescription,
          orderMarketComponentNumber,
          orderCreated,
          orderUserUsername,
          orderStatus,
          orderCriticalDate,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ReportingApi.apiReportingmarketComponentHistoryGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {string} report Reporting identifier
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportingmarketComponentReportGetCollectionOrderNumberEnum} [orderNumber]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum} [orderCreated]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum} [orderShortDescription]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum} [orderDescription]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum} [orderMarketComponentArticleTypeName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum} [orderMarketComponentTypeName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum} [orderMarketName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum} [orderMarketComponentHistoriesCreated]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportingmarketComponentReportGetCollection(
      report: string,
      page?: number,
      itemsPerPage?: number,
      orderNumber?: ApiReportingmarketComponentReportGetCollectionOrderNumberEnum,
      orderCreated?: ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum,
      orderShortDescription?: ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum,
      orderDescription?: ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum,
      orderMarketComponentArticleTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum,
      orderMarketComponentTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum,
      orderMarketName?: ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum,
      orderMarketComponentHistoriesCreated?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ReportingMarketComponentOutput>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportingmarketComponentReportGetCollection(
          report,
          page,
          itemsPerPage,
          orderNumber,
          orderCreated,
          orderShortDescription,
          orderDescription,
          orderMarketComponentArticleTypeName,
          orderMarketComponentTypeName,
          orderMarketName,
          orderMarketComponentHistoriesCreated,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ReportingApi.apiReportingmarketComponentReportGetCollection"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportinguserGetCollectionOrderUsernameEnum} [orderUsername]
     * @param {ApiReportinguserGetCollectionOrderFirstnameEnum} [orderFirstname]
     * @param {ApiReportinguserGetCollectionOrderLastnameEnum} [orderLastname]
     * @param {ApiReportinguserGetCollectionOrderDeactivatedEnum} [orderDeactivated]
     * @param {ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum} [orderDeactivatedByUsername]
     * @param {ApiReportinguserGetCollectionOrderCheckCountEnum} [orderCheckCount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiReportinguserGetCollection(
      page?: number,
      itemsPerPage?: number,
      orderUsername?: ApiReportinguserGetCollectionOrderUsernameEnum,
      orderFirstname?: ApiReportinguserGetCollectionOrderFirstnameEnum,
      orderLastname?: ApiReportinguserGetCollectionOrderLastnameEnum,
      orderDeactivated?: ApiReportinguserGetCollectionOrderDeactivatedEnum,
      orderDeactivatedByUsername?: ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum,
      orderCheckCount?: ApiReportinguserGetCollectionOrderCheckCountEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ReportingUserOutput>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiReportinguserGetCollection(
          page,
          itemsPerPage,
          orderUsername,
          orderFirstname,
          orderLastname,
          orderDeactivated,
          orderDeactivatedByUsername,
          orderCheckCount,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ReportingApi.apiReportinguserGetCollection"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ReportingApi - factory interface
 * @export
 */
export const ReportingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReportingApiFp(configuration);
  return {
    /**
     * Retrieves a Reporting resource.
     * @summary Retrieves a Reporting resource.
     * @param {string} report Reporting identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportingcsvExportReportGet(
      report: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .apiReportingcsvExportReportGet(report, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum} [orderMarketComponentMarketName]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum} [orderMarketComponentShortDescription]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum} [orderMarketComponentNumber]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum} [orderCreated]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum} [orderUserUsername]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum} [orderStatus]
     * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum} [orderCriticalDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportingmarketComponentHistoryGetCollection(
      page?: number,
      itemsPerPage?: number,
      orderMarketComponentMarketName?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum,
      orderMarketComponentShortDescription?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum,
      orderMarketComponentNumber?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum,
      orderCreated?: ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum,
      orderUserUsername?: ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum,
      orderStatus?: ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum,
      orderCriticalDate?: ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ReportingMarketComponentHistoryOutput>> {
      return localVarFp
        .apiReportingmarketComponentHistoryGetCollection(
          page,
          itemsPerPage,
          orderMarketComponentMarketName,
          orderMarketComponentShortDescription,
          orderMarketComponentNumber,
          orderCreated,
          orderUserUsername,
          orderStatus,
          orderCriticalDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {string} report Reporting identifier
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportingmarketComponentReportGetCollectionOrderNumberEnum} [orderNumber]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum} [orderCreated]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum} [orderShortDescription]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum} [orderDescription]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum} [orderMarketComponentArticleTypeName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum} [orderMarketComponentTypeName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum} [orderMarketName]
     * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum} [orderMarketComponentHistoriesCreated]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportingmarketComponentReportGetCollection(
      report: string,
      page?: number,
      itemsPerPage?: number,
      orderNumber?: ApiReportingmarketComponentReportGetCollectionOrderNumberEnum,
      orderCreated?: ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum,
      orderShortDescription?: ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum,
      orderDescription?: ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum,
      orderMarketComponentArticleTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum,
      orderMarketComponentTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum,
      orderMarketName?: ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum,
      orderMarketComponentHistoriesCreated?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ReportingMarketComponentOutput>> {
      return localVarFp
        .apiReportingmarketComponentReportGetCollection(
          report,
          page,
          itemsPerPage,
          orderNumber,
          orderCreated,
          orderShortDescription,
          orderDescription,
          orderMarketComponentArticleTypeName,
          orderMarketComponentTypeName,
          orderMarketName,
          orderMarketComponentHistoriesCreated,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of Reporting resources.
     * @summary Retrieves the collection of Reporting resources.
     * @param {number} [page] The collection page number
     * @param {number} [itemsPerPage] The number of items per page
     * @param {ApiReportinguserGetCollectionOrderUsernameEnum} [orderUsername]
     * @param {ApiReportinguserGetCollectionOrderFirstnameEnum} [orderFirstname]
     * @param {ApiReportinguserGetCollectionOrderLastnameEnum} [orderLastname]
     * @param {ApiReportinguserGetCollectionOrderDeactivatedEnum} [orderDeactivated]
     * @param {ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum} [orderDeactivatedByUsername]
     * @param {ApiReportinguserGetCollectionOrderCheckCountEnum} [orderCheckCount]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiReportinguserGetCollection(
      page?: number,
      itemsPerPage?: number,
      orderUsername?: ApiReportinguserGetCollectionOrderUsernameEnum,
      orderFirstname?: ApiReportinguserGetCollectionOrderFirstnameEnum,
      orderLastname?: ApiReportinguserGetCollectionOrderLastnameEnum,
      orderDeactivated?: ApiReportinguserGetCollectionOrderDeactivatedEnum,
      orderDeactivatedByUsername?: ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum,
      orderCheckCount?: ApiReportinguserGetCollectionOrderCheckCountEnum,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ReportingUserOutput>> {
      return localVarFp
        .apiReportinguserGetCollection(
          page,
          itemsPerPage,
          orderUsername,
          orderFirstname,
          orderLastname,
          orderDeactivated,
          orderDeactivatedByUsername,
          orderCheckCount,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ReportingApi - object-oriented interface
 * @export
 * @class ReportingApi
 * @extends {BaseAPI}
 */
export class ReportingApi extends BaseAPI {
  /**
   * Retrieves a Reporting resource.
   * @summary Retrieves a Reporting resource.
   * @param {string} report Reporting identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public apiReportingcsvExportReportGet(
    report: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingApiFp(this.configuration)
      .apiReportingcsvExportReportGet(report, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Reporting resources.
   * @summary Retrieves the collection of Reporting resources.
   * @param {number} [page] The collection page number
   * @param {number} [itemsPerPage] The number of items per page
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum} [orderMarketComponentMarketName]
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum} [orderMarketComponentShortDescription]
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum} [orderMarketComponentNumber]
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum} [orderCreated]
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum} [orderUserUsername]
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum} [orderStatus]
   * @param {ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum} [orderCriticalDate]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public apiReportingmarketComponentHistoryGetCollection(
    page?: number,
    itemsPerPage?: number,
    orderMarketComponentMarketName?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum,
    orderMarketComponentShortDescription?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum,
    orderMarketComponentNumber?: ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum,
    orderCreated?: ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum,
    orderUserUsername?: ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum,
    orderStatus?: ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum,
    orderCriticalDate?: ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingApiFp(this.configuration)
      .apiReportingmarketComponentHistoryGetCollection(
        page,
        itemsPerPage,
        orderMarketComponentMarketName,
        orderMarketComponentShortDescription,
        orderMarketComponentNumber,
        orderCreated,
        orderUserUsername,
        orderStatus,
        orderCriticalDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Reporting resources.
   * @summary Retrieves the collection of Reporting resources.
   * @param {string} report Reporting identifier
   * @param {number} [page] The collection page number
   * @param {number} [itemsPerPage] The number of items per page
   * @param {ApiReportingmarketComponentReportGetCollectionOrderNumberEnum} [orderNumber]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum} [orderCreated]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum} [orderShortDescription]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum} [orderDescription]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum} [orderMarketComponentArticleTypeName]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum} [orderMarketComponentTypeName]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum} [orderMarketName]
   * @param {ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum} [orderMarketComponentHistoriesCreated]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public apiReportingmarketComponentReportGetCollection(
    report: string,
    page?: number,
    itemsPerPage?: number,
    orderNumber?: ApiReportingmarketComponentReportGetCollectionOrderNumberEnum,
    orderCreated?: ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum,
    orderShortDescription?: ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum,
    orderDescription?: ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum,
    orderMarketComponentArticleTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum,
    orderMarketComponentTypeName?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum,
    orderMarketName?: ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum,
    orderMarketComponentHistoriesCreated?: ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingApiFp(this.configuration)
      .apiReportingmarketComponentReportGetCollection(
        report,
        page,
        itemsPerPage,
        orderNumber,
        orderCreated,
        orderShortDescription,
        orderDescription,
        orderMarketComponentArticleTypeName,
        orderMarketComponentTypeName,
        orderMarketName,
        orderMarketComponentHistoriesCreated,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of Reporting resources.
   * @summary Retrieves the collection of Reporting resources.
   * @param {number} [page] The collection page number
   * @param {number} [itemsPerPage] The number of items per page
   * @param {ApiReportinguserGetCollectionOrderUsernameEnum} [orderUsername]
   * @param {ApiReportinguserGetCollectionOrderFirstnameEnum} [orderFirstname]
   * @param {ApiReportinguserGetCollectionOrderLastnameEnum} [orderLastname]
   * @param {ApiReportinguserGetCollectionOrderDeactivatedEnum} [orderDeactivated]
   * @param {ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum} [orderDeactivatedByUsername]
   * @param {ApiReportinguserGetCollectionOrderCheckCountEnum} [orderCheckCount]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingApi
   */
  public apiReportinguserGetCollection(
    page?: number,
    itemsPerPage?: number,
    orderUsername?: ApiReportinguserGetCollectionOrderUsernameEnum,
    orderFirstname?: ApiReportinguserGetCollectionOrderFirstnameEnum,
    orderLastname?: ApiReportinguserGetCollectionOrderLastnameEnum,
    orderDeactivated?: ApiReportinguserGetCollectionOrderDeactivatedEnum,
    orderDeactivatedByUsername?: ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum,
    orderCheckCount?: ApiReportinguserGetCollectionOrderCheckCountEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingApiFp(this.configuration)
      .apiReportinguserGetCollection(
        page,
        itemsPerPage,
        orderUsername,
        orderFirstname,
        orderLastname,
        orderDeactivated,
        orderDeactivatedByUsername,
        orderCheckCount,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentMarketNameEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentShortDescriptionEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderMarketComponentNumberEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderCreatedEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderUserUsernameEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderStatusEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum =
  (typeof ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum)[keyof typeof ApiReportingmarketComponentHistoryGetCollectionOrderCriticalDateEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderNumberEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportingmarketComponentReportGetCollectionOrderNumberEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderNumberEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderNumberEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderCreatedEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderShortDescriptionEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderDescriptionEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderMarketComponentArticleTypeNameEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderMarketComponentTypeNameEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderMarketNameEnum];
/**
 * @export
 */
export const ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum =
  {
    Asc: "asc",
    Desc: "desc",
  } as const;
export type ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum =
  (typeof ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum)[keyof typeof ApiReportingmarketComponentReportGetCollectionOrderMarketComponentHistoriesCreatedEnum];
/**
 * @export
 */
export const ApiReportinguserGetCollectionOrderUsernameEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportinguserGetCollectionOrderUsernameEnum =
  (typeof ApiReportinguserGetCollectionOrderUsernameEnum)[keyof typeof ApiReportinguserGetCollectionOrderUsernameEnum];
/**
 * @export
 */
export const ApiReportinguserGetCollectionOrderFirstnameEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportinguserGetCollectionOrderFirstnameEnum =
  (typeof ApiReportinguserGetCollectionOrderFirstnameEnum)[keyof typeof ApiReportinguserGetCollectionOrderFirstnameEnum];
/**
 * @export
 */
export const ApiReportinguserGetCollectionOrderLastnameEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportinguserGetCollectionOrderLastnameEnum =
  (typeof ApiReportinguserGetCollectionOrderLastnameEnum)[keyof typeof ApiReportinguserGetCollectionOrderLastnameEnum];
/**
 * @export
 */
export const ApiReportinguserGetCollectionOrderDeactivatedEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportinguserGetCollectionOrderDeactivatedEnum =
  (typeof ApiReportinguserGetCollectionOrderDeactivatedEnum)[keyof typeof ApiReportinguserGetCollectionOrderDeactivatedEnum];
/**
 * @export
 */
export const ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum =
  (typeof ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum)[keyof typeof ApiReportinguserGetCollectionOrderDeactivatedByUsernameEnum];
/**
 * @export
 */
export const ApiReportinguserGetCollectionOrderCheckCountEnum = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ApiReportinguserGetCollectionOrderCheckCountEnum =
  (typeof ApiReportinguserGetCollectionOrderCheckCountEnum)[keyof typeof ApiReportinguserGetCollectionOrderCheckCountEnum];

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {UserUserIO} userUserIO The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserPost: async (
      userUserIO: UserUserIO,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userUserIO' is not null or undefined
      assertParamExists("apiUserPost", "userUserIO", userUserIO);
      const localVarPath = `/api/user`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userUserIO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {UserUserResetPasswordInput} userUserResetPasswordInput The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserResetPasswordPut: async (
      userUserResetPasswordInput: UserUserResetPasswordInput,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userUserResetPasswordInput' is not null or undefined
      assertParamExists(
        "apiUserResetPasswordPut",
        "userUserResetPasswordInput",
        userUserResetPasswordInput,
      );
      const localVarPath = `/api/user_reset_password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userUserResetPasswordInput,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {UserUserDeactivateActivateInput} userUserDeactivateActivateInput The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersDeactivateActivatePut: async (
      userUserDeactivateActivateInput: UserUserDeactivateActivateInput,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userUserDeactivateActivateInput' is not null or undefined
      assertParamExists(
        "apiUsersDeactivateActivatePut",
        "userUserDeactivateActivateInput",
        userUserDeactivateActivateInput,
      );
      const localVarPath = `/api/users_deactivate_activate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userUserDeactivateActivateInput,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the collection of User resources.
     * @summary Retrieves the collection of User resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersGetCollection: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {UserUserIO} userUserIO The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserPost(
      userUserIO: UserUserIO,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserUserIO>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPost(
        userUserIO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserApi.apiUserPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {UserUserResetPasswordInput} userUserResetPasswordInput The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserResetPasswordPut(
      userUserResetPasswordInput: UserUserResetPasswordInput,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserSuccessOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserResetPasswordPut(
          userUserResetPasswordInput,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserApi.apiUserResetPasswordPut"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {UserUserDeactivateActivateInput} userUserDeactivateActivateInput The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUsersDeactivateActivatePut(
      userUserDeactivateActivateInput: UserUserDeactivateActivateInput,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserSuccessOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUsersDeactivateActivatePut(
          userUserDeactivateActivateInput,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserApi.apiUsersDeactivateActivatePut"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves the collection of User resources.
     * @summary Retrieves the collection of User resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUsersGetCollection(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<UserUserIO>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUsersGetCollection(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserApi.apiUsersGetCollection"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserApiFp(configuration);
  return {
    /**
     * Creates a User resource.
     * @summary Creates a User resource.
     * @param {UserUserIO} userUserIO The new User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserPost(
      userUserIO: UserUserIO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserUserIO> {
      return localVarFp
        .apiUserPost(userUserIO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {UserUserResetPasswordInput} userUserResetPasswordInput The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserResetPasswordPut(
      userUserResetPasswordInput: UserUserResetPasswordInput,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserSuccessOutput> {
      return localVarFp
        .apiUserResetPasswordPut(userUserResetPasswordInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Replaces the User resource.
     * @summary Replaces the User resource.
     * @param {UserUserDeactivateActivateInput} userUserDeactivateActivateInput The updated User resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersDeactivateActivatePut(
      userUserDeactivateActivateInput: UserUserDeactivateActivateInput,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserSuccessOutput> {
      return localVarFp
        .apiUsersDeactivateActivatePut(userUserDeactivateActivateInput, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the collection of User resources.
     * @summary Retrieves the collection of User resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUsersGetCollection(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<UserUserIO>> {
      return localVarFp
        .apiUsersGetCollection(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   * Creates a User resource.
   * @summary Creates a User resource.
   * @param {UserUserIO} userUserIO The new User resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public apiUserPost(userUserIO: UserUserIO, options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .apiUserPost(userUserIO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the User resource.
   * @summary Replaces the User resource.
   * @param {UserUserResetPasswordInput} userUserResetPasswordInput The updated User resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public apiUserResetPasswordPut(
    userUserResetPasswordInput: UserUserResetPasswordInput,
    options?: RawAxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .apiUserResetPasswordPut(userUserResetPasswordInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Replaces the User resource.
   * @summary Replaces the User resource.
   * @param {UserUserDeactivateActivateInput} userUserDeactivateActivateInput The updated User resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public apiUsersDeactivateActivatePut(
    userUserDeactivateActivateInput: UserUserDeactivateActivateInput,
    options?: RawAxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .apiUsersDeactivateActivatePut(userUserDeactivateActivateInput, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the collection of User resources.
   * @summary Retrieves the collection of User resources.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public apiUsersGetCollection(options?: RawAxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .apiUsersGetCollection(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserMarketsApi - axios parameter creator
 * @export
 */
export const UserMarketsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a User Markets resource.
     * @summary Creates a User Markets resource.
     * @param {UserMarketsUserMarketsIO} userMarketsUserMarketsIO The new User Markets resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserMarketsPost: async (
      userMarketsUserMarketsIO: UserMarketsUserMarketsIO,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userMarketsUserMarketsIO' is not null or undefined
      assertParamExists(
        "apiUserMarketsPost",
        "userMarketsUserMarketsIO",
        userMarketsUserMarketsIO,
      );
      const localVarPath = `/api/user_markets`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        userMarketsUserMarketsIO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves a User Markets resource.
     * @summary Retrieves a User Markets resource.
     * @param {string} username User Markets identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserMarketsUsernameGet: async (
      username: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'username' is not null or undefined
      assertParamExists("apiUserMarketsUsernameGet", "username", username);
      const localVarPath = `/api/user_markets/{username}`.replace(
        `{${"username"}}`,
        encodeURIComponent(String(username)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserMarketsApi - functional programming interface
 * @export
 */
export const UserMarketsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UserMarketsApiAxiosParamCreator(configuration);
  return {
    /**
     * Creates a User Markets resource.
     * @summary Creates a User Markets resource.
     * @param {UserMarketsUserMarketsIO} userMarketsUserMarketsIO The new User Markets resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserMarketsPost(
      userMarketsUserMarketsIO: UserMarketsUserMarketsIO,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserMarketsSuccessOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserMarketsPost(
          userMarketsUserMarketsIO,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserMarketsApi.apiUserMarketsPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Retrieves a User Markets resource.
     * @summary Retrieves a User Markets resource.
     * @param {string} username User Markets identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserMarketsUsernameGet(
      username: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserMarketsUserMarketsIO>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserMarketsUsernameGet(
          username,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserMarketsApi.apiUserMarketsUsernameGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserMarketsApi - factory interface
 * @export
 */
export const UserMarketsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserMarketsApiFp(configuration);
  return {
    /**
     * Creates a User Markets resource.
     * @summary Creates a User Markets resource.
     * @param {UserMarketsUserMarketsIO} userMarketsUserMarketsIO The new User Markets resource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserMarketsPost(
      userMarketsUserMarketsIO: UserMarketsUserMarketsIO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserMarketsSuccessOutput> {
      return localVarFp
        .apiUserMarketsPost(userMarketsUserMarketsIO, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves a User Markets resource.
     * @summary Retrieves a User Markets resource.
     * @param {string} username User Markets identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserMarketsUsernameGet(
      username: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserMarketsUserMarketsIO> {
      return localVarFp
        .apiUserMarketsUsernameGet(username, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserMarketsApi - object-oriented interface
 * @export
 * @class UserMarketsApi
 * @extends {BaseAPI}
 */
export class UserMarketsApi extends BaseAPI {
  /**
   * Creates a User Markets resource.
   * @summary Creates a User Markets resource.
   * @param {UserMarketsUserMarketsIO} userMarketsUserMarketsIO The new User Markets resource
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserMarketsApi
   */
  public apiUserMarketsPost(
    userMarketsUserMarketsIO: UserMarketsUserMarketsIO,
    options?: RawAxiosRequestConfig,
  ) {
    return UserMarketsApiFp(this.configuration)
      .apiUserMarketsPost(userMarketsUserMarketsIO, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves a User Markets resource.
   * @summary Retrieves a User Markets resource.
   * @param {string} username User Markets identifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserMarketsApi
   */
  public apiUserMarketsUsernameGet(
    username: string,
    options?: RawAxiosRequestConfig,
  ) {
    return UserMarketsApiFp(this.configuration)
      .apiUserMarketsUsernameGet(username, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserProfileApi - axios parameter creator
 * @export
 */
export const UserProfileApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves a User Profile resource.
     * @summary Retrieves a User Profile resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/profile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserProfileApi - functional programming interface
 * @export
 */
export const UserProfileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UserProfileApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves a User Profile resource.
     * @summary Retrieves a User Profile resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiProfileGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserProfileProfileOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiProfileGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["UserProfileApi.apiProfileGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * UserProfileApi - factory interface
 * @export
 */
export const UserProfileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserProfileApiFp(configuration);
  return {
    /**
     * Retrieves a User Profile resource.
     * @summary Retrieves a User Profile resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProfileGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<UserProfileProfileOutput> {
      return localVarFp
        .apiProfileGet(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserProfileApi - object-oriented interface
 * @export
 * @class UserProfileApi
 * @extends {BaseAPI}
 */
export class UserProfileApi extends BaseAPI {
  /**
   * Retrieves a User Profile resource.
   * @summary Retrieves a User Profile resource.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserProfileApi
   */
  public apiProfileGet(options?: RawAxiosRequestConfig) {
    return UserProfileApiFp(this.configuration)
      .apiProfileGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * VersionApi - axios parameter creator
 * @export
 */
export const VersionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieves a Version resource.
     * @summary Retrieves a Version resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVersionGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/version`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VersionApi - functional programming interface
 * @export
 */
export const VersionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieves a Version resource.
     * @summary Retrieves a Version resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiVersionGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<VersionVersionOutput>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiVersionGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["VersionApi.apiVersionGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * VersionApi - factory interface
 * @export
 */
export const VersionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = VersionApiFp(configuration);
  return {
    /**
     * Retrieves a Version resource.
     * @summary Retrieves a Version resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiVersionGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<VersionVersionOutput> {
      return localVarFp
        .apiVersionGet(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * VersionApi - object-oriented interface
 * @export
 * @class VersionApi
 * @extends {BaseAPI}
 */
export class VersionApi extends BaseAPI {
  /**
   * Retrieves a Version resource.
   * @summary Retrieves a Version resource.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VersionApi
   */
  public apiVersionGet(options?: RawAxiosRequestConfig) {
    return VersionApiFp(this.configuration)
      .apiVersionGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
